export const translation = {
  common: {
    logout: 'Одјава',
    account: 'Налог',
    myAccount: 'Мој налог',
    search: 'Претражи...',
    actions: 'Акције',
    view: 'Прегледај',
    details: 'Детаљи',
    edit: 'Измени',
    delete: 'Обриши',
    save: 'Сачувај',
    saving: 'Чување...',
    deleting: 'Брисање...',
    cancel: 'Одустани',
    close: 'Затвори',
    back: 'Назад',
    backToList: 'Назад на листу',
    moreActions: 'Више акција',
    backToVehicles: 'Назад на возила',
    new: 'Ново',
    create: 'Креирај',
    list: 'Листа',
    none: 'Ниједно',
    all: 'Све',
    filters: 'Филтери',
    clearFilters: 'Обриши филтере',
    noResults: 'Нема резултата',
    rowsPerPage: 'Редова по страници:',
    viewVehicle: 'Погледај возило',
    loading: 'Учитавање...',
    error: 'Грешка',
    success: 'Успешно',
    required: 'Обавезно поље',
    activeContracts: 'Активни уговори',
    viewAll: 'Прегледај све',
    errorLoadingData: 'Грешка при учитавању података',
    unlimited: 'Неограничено',
    confirm: 'Потврди',
    confirmTitles: {
      delete: 'Потврда брисања',
      archive: 'Потврда архивирања',
      restore: 'Потврда враћања из архиве',
      deactivate: 'Потврда деактивације',
      reactivate: 'Потврда поновног активирања',
      regenerate: 'Потврда регенерације',
    },
    show: 'Прикажи',
    hide: 'Сакриј',
    submit: 'Пошаљи',
    submitting: 'Слање...',
    yes: 'Да',
    no: 'Не',
    notSpecified: 'Није наведено',
    of: 'од',
    moreThan: 'више од',
    noOptions: 'Нема опција',
    selectOption: 'Изаберите опцију',
    months: {
      1: 'Јануар',
      2: 'Фебруар',
      3: 'Март',
      4: 'Април',
      5: 'Мај',
      6: 'Јун',
      7: 'Јул',
      8: 'Август',
      9: 'Септембар',
      10: 'Октобар',
      11: 'Новембар',
      12: 'Децембар',
    },
    pagination: {
      displayedRows: '{{from}}-{{to}} од {{total}}',
      moreThan: 'више од {{to}}',
    },
    validation: {
      // Required fields
      required: 'Ово поље је обавезно',

      // String validation
      minLength: 'Минимална дужина је {{min}} карактера',
      maxLength: 'Максимална дужина је {{max}} карактера',
      exactLength: 'Дужина мора бити тачно {{length}} карактера',

      // Number validation
      min: 'Минимална вредност је {{min}}',
      max: 'Максимална вредност је {{max}}',
      positive: 'Вредност мора бити позитиван број',
      nonNegative: 'Вредност не може бити негативна',
      integer: 'Вредност мора бити цео број',

      // Format validation
      invalidEmail: 'Неважећа email адреса',
      invalidPhone: 'Неважећи број телефона',
      invalidUrl: 'Неважећи URL',
      invalidDate: 'Неважећи датум',

      // Date validation
      dateInPast: 'Датум мора бити у прошлости',
      dateInFuture: 'Датум мора бити у будућности',
      dateTodayOrFuture: 'Датум мора бити данас или у будућности',
      dateAfter: 'Датум мора бити после {{date}}',
      dateBefore: 'Датум мора бити пре {{date}}',
      endDateAfterStartDate: 'Датум завршетка мора бити после датума почетка',

      // Custom validations
      duplicate: 'Ова вредност већ постоји',
      notFound: 'Вредност није пронађена',
      invalidFormat: 'Неважећи формат',

      // General
      invalidValue: 'Неважећа вредност',
    },
    errors: {
      // General errors
      saveFailed: 'Грешка при чувању података',
      loadFailed: 'Грешка при учитавању података',
      deleteFailed: 'Грешка при брисању',
      unauthorized: 'Немате дозволу за ову акцију',
      networkError: 'Грешка у мрежи. Проверите интернет конекцију',
      unknownError: 'Дошло је до непознате грешке',
      validationErrors: 'Молимо исправите следеће грешке:',
    },
    unauthorized: {
      title: 'Неовлашћен приступ',
      message: 'Немате дозволу за приступ овој страници.',
      contactAdmin: 'Контактирајте администратора ако сматрате да је ово грешка.',
    },
    notFound: {
      title: 'Страница није пронађена',
      description: 'Страница коју тражите не постоји или је уклоњена.',
      goHome: 'Иди на почетну',
    },
  },
  app: {
    title: 'Платформа за пословање',
    company: 'Транспортгас Србија',
    moduleSwitcher: {
      title: 'Модули',
      change: 'Промени модул',
      changeCurrent: 'Промени модул, тренутно {{name}}',
      externalHint: 'Отвара се у новом табу',
    },
    moduleChooser: {
      title: 'Изаберите модул',
      subtitle: 'Следећи пут ћете бити враћени у модул у коме сте последњи пут радили.',
    },
  },
  language: {
    latin: 'Латиница',
    cyrillic: 'Ћирилица',
    latinShort: 'Лат',
    cyrillicShort: 'Ћир',
  },
  roles: {
    systemAdmin: 'Систем Администратор',
    fleetManager: 'Менаџер',
    fleetUser: 'Корисник',
    fleetViewOnly: 'Преглед возног парка',
    fleetTireService: 'Вулканизерске услуге',
    fleetRegistrations: 'Регистрације возила',
    fleetServices: 'Сервиси возила',
    fleetTravelOrders: 'Путни налози',
    fleetRequestForOthers: 'Захтеви у туђе име',
    contractManager: 'Менаџер уговора',
    userAdmin: 'Администратор корисника',
    hrManager: 'Кадровска',
    documentArchiveUser: 'Корисник архиве докумената',
  },
  nav: {
    dashboard: 'Контролна табла',
  },
  modules: {
    fleet: {
      name: 'Возни парк',
    },
    users: {
      name: 'Корисници',
    },
    humanResources: {
      name: 'Кадровска',
    },
  },
  fleets: {
    dashboard: {
      subtitle: 'Преглед возног парка',
    },
    nav: {
      vehicles: 'Возила',
      allVehicles: 'Сва возила',
      requests: 'Захтеви',
      operations: 'Операције',
      services: 'Сервисни трошкови',
      fuel: 'Гориво',
      tires: 'Вулканизерски трошкови',
      registrations: 'Регистрације',
      contracts: 'Уговори',
      activeContracts: 'Активни уговори',
      providers: 'Добављачи',
      travelOrders: 'Вожње',
      travelOrderPeriods: 'Путни налози',
      fleetUsers: 'Корисници',
      myAccount: 'Мој налог',
      reports: 'Извештаји',
      tireTracking: 'Евиденција гума',
      workOrders: 'Радни налози',
      operationalUnits: 'Орг. јединице',
    },
    vehicles: {
      title: 'Возила',
      subtitle: 'Једноставан увид у детаље возила',
      noVehicles: 'Нема возила у вашој организационој јединици.',
      add: 'Додај возило',
      addVehicle: 'Додај ново возило',
      editVehicle: 'Измени возило',
      createRequest: 'Креирај захтев',
      createRequestTooltip: 'Креирај захтев за коришћење возила',
      notFound: 'Возило није пронађено',
      registration: 'Регистарска ознака',
      assignedTo: 'Задужио',
      travelOrderHolder: 'Носилац налога',
      travelOrderHolderPrevious: 'Последњи налог, није активан',
      brand: 'Марка',
      model: 'Модел',
      type: 'Тип',
      year: 'Година',
      status: 'Статус',
      color: 'Боја',
      chassisNumber: 'Број шасије',
      engineNumber: 'Број мотора',
      enginePower: 'Снага мотора',
      fuelType: 'Тип горива',
      mileage: 'Километража',
      registrationNumber: 'Број саобраћајне',
      internalCode: 'Интерни број',
      registrationDate: 'Датум регистрације',
      registrationExpiry: 'Истек регистрације',
      generalInfo: 'Општи подаци',
      basicInfoMenu: 'Подаци о возилу',
      registrationInfo: 'Регистрација',
      vehicleIsRegistered: 'Возило је регистровано',
      technicalInfo: 'Технички подаци',
      serviceHistory: 'Историја сервиса',
      tireServiceHistory: 'Историја вулканизерских трошкова',
      fuelLogs: 'Евиденција горива',
      noServiceHistory: 'Нема историје сервиса',
      noTireServiceHistory: 'Нема историје вулканизерских трошкова',
      noFuelLogs: 'Нема евиденције горива',
      noDocuments: 'Нема докумената',
      tabs: {
        basicInfo: 'Основни подаци',
        services: 'Сервисни трошкови',
        vulcanizerServices: 'Вулканизерски трошкови',
        registrations: 'Регистрације',
        fuel: 'Гориво',
        assigmnets: 'Доделe',
        travelOrderPeriods: 'Путни налози',
        unavailability: 'Недоступност',
        tires: 'Гуме',
        travelOrders: 'Вожње',
        unitTransfers: 'Премештаји',
        odometerCorrections: 'Корекције километраже',
      },
      assignmentTab: {
        title: 'Додељење возила',
        assign: 'Додели возило',
        currentAssignment: 'Тренутна додела',
        assignedToUser: 'Додељен кориснику',
        contractNumber: 'Број уговора',
        assignmentPeriod: 'Период доделе',
        indeterminate: 'Неодређено',
        activeTravelOrder: 'Активни путни налог',
        active: 'Активни',
        responsiblePerson: 'Носилац налога',
        tripCount: 'Број вожњи',
        view: 'Погледај',
        createNewPeriod: 'Креирај нови путни налог',
        noPeriodCurrentMonth: 'Нема путног налога за текући месец',
        createPeriod: 'Креирај путни налог',
        noActiveAssignment: 'Возило нема активну доделу.',
      },
      travelOrderPeriodsTab: {
        title: 'Путни налози',
        empty: 'Нема путних налога за ово возило',
      },
      unavailabilityTab: {
        title: 'Недоступност возила',
        activeOnly: 'Само активне',
        all: 'Све',
        create: 'Нова недоступност',
      },
      tiresTab: {
        title: 'Гуме на возилу',
        addNew: 'Додај нову гуму',
        mountExisting: 'Монтирај постојећу',
        empty: 'Нема монтираних гума на овом возилу.',
      },
      travelOrdersTab: {
        title: 'Вожње',
      },
      unitTransfersTab: {
        title: 'Историја премештаја између јединица',
        empty: 'Возило није премештано између јединица.',
        transferredAt: 'Датум премештаја',
        from: 'Из јединице',
        to: 'У јединицу',
        transferredBy: 'Извршио',
        notes: 'Напомена',
      },
      odometerCorrectionsTab: {
        title: 'Историја корекција километраже',
      },
      requestPool: {
        label: 'Доступно за захтеве',
        notAvailable: 'Није доступно за захтеве',
        outOfPool: 'Ван пула',
        tooltip: 'Контролише да ли стандардни корисници виде ово возило и могу да га затраже',
        yes: 'Да',
        no: 'Не',
      },
      createPeriod: {
        title: 'Креирај путни налог',
        description: 'Креирање новог путног налога за возило {{plate}}.',
        vehicle: 'Возило',
        responsiblePerson: 'Носилац налога',
        month: 'Месец',
        year: 'Година',
        creating: 'Креирање...',
        submit: 'Креирај путни налог за {{period}}',
      },
      // Form field labels (matching English property names)
      fields: {
        plateNumber: 'Регистарска ознака',
        plateNumberHint: 'Уноси се без размака и цртица, нпр. NS123AB',
        brand: 'Марка',
        model: 'Модел',
        vehicleType: 'Тип возила',
        productionDate: 'Датум производње',
        chassisNumber: 'Број шасије',
        registrationNumber: 'Број саобраћајне',
        registrationDate: 'Датум регистрације',
        registrationExpiry: 'Истек регистрације',
        wheelDimension: 'Димензија точка',
        odometer: 'Километража',
        engineNumber: 'Број мотора',
        powerKW: 'Снага мотора (kW)',
        capacityCM3: 'Запремина (cm³)',
        fuelType: 'Тип горива',
        color: 'Боја',
        passengerSeats: 'Број седишта',
        fuelCardNumber: 'Број картице за гориво',
        currentDriverId: 'Запослени',
        referenceConsumption: 'Референтна потрошња (L/100km)',
        referenceConsumptionHelper: 'Очекивана фабричка потрошња возила. Оставите празно да онемогућите анализу.',
        consumptionTolerance: 'Толеранција (±%)',
        consumptionToleranceHelper: 'Дозвољено одступање од референце, симетрично у оба смера (нпр. 10 значи ±10%).',
      },
      filters: {
        brand: 'Марка',
        brandPlaceholder: 'Нпр. Toyota',
        plateNumber: 'Регистарска ознака',
        plateNumberPlaceholder: 'Нпр. NS501NZ или 501',
        travelOrderHolder: 'Носилац путног налога',
        travelOrderHolderPlaceholder: 'Име или презиме',
        internalCode: 'Интерни број',
        internalCodePlaceholder: 'Нпр. BG, NS или PA-1',
        operationalUnit: 'Транспортна јединица',
        operationalUnitPlaceholder: 'Изаберите јединице',
        fuelTypePlaceholder: 'Изаберите тип горива',
        availableFrom: 'Доступно од',
        availableTo: 'Доступно до',
        assignmentStatus: 'Статус додељивања',
        assignmentStatusPlaceholder: 'Изаберите статус',
        withAssignee: 'Са додељеним корисником',
        withoutAssignee: 'Без додељеног корисника',
        requestPool: 'Пул захтева',
        requestPoolPlaceholder: 'Изаберите статус',
        inRequestPool: 'У пулу захтева',
        notInRequestPool: 'Ван пула захтева',
      },
      columns: {
        internalCode: 'Број',
        requestPool: 'За захтеве',
      },
      consumptionAnalysis: 'Анализа потрошње горива',
      vehicleTypes: {
        Passenger: 'Путничко',
        Cargo: 'Теретно',
        Special: 'Специјално',
        Work: 'Радно',
        Trailer: 'Прикључно',
      },
      statuses: {
        Active: 'Активно',
        Sold: 'Продато',
        Scrapped: 'Отписано',
        Unknown: 'Непознато',
      },
      unavailableReason: 'Возило је {{status}}',
      availability: {
        title: 'Доступност возила',
        errorLoading: 'Грешка при учитавању података о доступности',
        free: 'Слободно',
        hoursOf24: '{{hours}}h од 24h ({{percent}}%)',
        eventTypes: {
          travelOrder: 'Заузето',
          service: 'Сервис',
          outOfService: 'Ван функције',
          manual: 'Резервација',
          unavailable: 'Недоступно',
        },
      },
      adjustOdometer: {
        title: 'Корекција километраже',
        button: 'Корекција',
        odometerHelper: 'Километража се ажурира путем вожњи или корекције',
        newOdometer: 'Ново стање километраже',
        reason: 'Разлог корекције',
        reasonHelper: 'Обавезно: Унесите разлог за корекцију километраже',
        currentState: 'Тренутно стање:',
        saving: 'Чување...',
        submit: 'Ажурирај километражу',
        allowedRange: 'Дозвољени опсег за ново стање',
        belowLastReadingInfo: 'Ново стање не може бити мање од последњег очитавања. Ако је неко очитавање погрешно, исправите га на вожњи или путном налогу.',
        validation: {
          odometerRequired: 'Унесите ново стање километраже',
          odometerNonNegative: 'Километража не може бити негативна',
          odometerDifferent: 'Нова километража мора бити различита од тренутне',
          reasonRequired: 'Разлог корекције је обавезан',
          reasonTooLong: 'Разлог не може бити дужи од 500 карактера',
          belowLastReading: 'Стање не може бити мање од последњег очитавања ({{value}}). Исправите погрешно очитавање на вожњи или путном налогу.',
        },
      },
      transfer: {
        button: 'Премести',
        title: 'Премештај возила {{plate}}',
        currentUnit: 'Тренутна јединица:',
        info: 'Премештај важи од данас. Отворени путни налог и будуће вожње прелазе у нову јединицу, а ранији записи остају у старој јединици.',
        targetUnit: 'Нова јединица',
        targetUnitHelper: 'Ако се мења град, возило добија нови интерни број.',
        newDriver: 'Нови задужени запослени (опционо)',
        newDriverHelper: 'Оставите празно да задужење остане непромењено.',
        transferPeriodHolder: 'Пренеси и носиоца отвореног путног налога',
        notes: 'Напомена',
        saving: 'Премештање...',
        submit: 'Премести возило',
        unitReadOnlyHelper: 'Јединица се мења преко опције „Премести” на страници возила.',
        validation: {
          targetUnitRequired: 'Изаберите нову јединицу',
          notesTooLong: 'Напомена не може бити дужа од 500 карактера',
        },
      },
    },
    services: {
      title: 'Сервиси',
      subtitle: 'Преглед и управљање сервисима возила',
      add: 'Нови сервис',
      create: 'Нови сервис',
      edit: 'Измени сервис',
      pending: 'на чекању',
      loading: 'Учитавање сервиса...',
      notFound: 'Сервис није пронађен или је дошло до грешке при учитавању.',
      errorLoading: 'Грешка при учитавању сервиса. Покушајте поново.',
      notSpecified: 'Није наведено',
      viewVehicle: 'Погледај возило',

      // Table columns
      vehicle: 'Возило',
      type: 'Тип',
      description: 'Опис',
      scheduledDate: 'Датум',
      provider: 'Сервисер',
      cost: 'Трошак',
      status: 'Статус',

      // Form sections
      form: {
        basicInfo: 'Основни подаци',
        providerSection: 'Добављач / Сервисер',
        invoiceSection: 'Фактура и напомене',
        itemsSection: 'Ставке сервиса',
        notesSection: 'Напомене',
        newService: 'Нови сервис',
        editService: 'Измени сервис',
      },

      // Fields
      fields: {
        vehicle: 'Возило',
        odometerReading: 'Стање километраже',
        description: 'Опис сервиса',
        descriptionPlaceholder: 'Нпр. Редован сервис 30.000 км - замена уља и филтера',
        provider: 'Добављач',
        providerNotSelected: 'Није одабрано',
        providerNone: 'Није одабрано',
        contract: 'Уговор',
        customProviderName: 'Назив сервисера (ручни унос)',
        invoiceNumber: 'Број фактуре',
        notes: 'Напомене',
        notesPlaceholder: 'Додатне напомене о сервису...',
      },

      // Detail page
      detail: {
        basicInfo: 'Основни подаци',
        vehicle: 'Возило',
        odometer: 'Километража',
        createdAt: 'Датум креирања',
        updatedAt: 'Датум измене',
        invoiceNumber: 'Број фактуре',
        provider: 'Добављач',
        totalCost: 'Укупан трошак',
        notes: 'Напомене',
        items: 'Ставке сервиса',
        itemCount: 'ставка',
        itemsCount: 'ставки',
      },

      // Service items
      items: {
        title: 'Ставке сервиса',
        add: 'Додај ставку',
        addButton: 'Додај',
        edit: 'Измени ставку',
        editTooltip: 'Измени',
        delete: 'Обриши ставку',
        deleteTooltip: 'Обриши',
        noItems: 'Нема ставки',
        noItemsHint: 'Кликните "Додај ставку" да додате прву ставку сервиса',
        noItemsHintMobile: 'Кликните "Додај" да додате прву ставку сервиса',
        noItemsDetail: 'Овај сервис нема додатих ставки',
        total: 'Укупно',
        totalLabel: 'УКУПНО:',

        // Table columns
        type: 'Тип',
        description: 'Опис',
        quantity: 'Кол.',
        quantityFull: 'Количина',
        unitPrice: 'Цена',
        unitPriceFull: 'Цена по јединици',
        totalPrice: 'Укупно',
        actions: 'Акције',

        // Item types
        types: {
          Other: 'Остало',
          Work: 'Рад',
          Part: 'Део',
          Tire: 'Гума',
          Fee: 'Накнада',
        },
      },

      // Add/Edit item dialog
      itemDialog: {
        addTitle: 'Додај ставку',
        editTitle: 'Измени ставку',
        itemType: 'Тип ставке',
        description: 'Опис',
        descriptionPlaceholder: 'Нпр. Замена уља и филтера',
        quantity: 'Количина',
        unitPrice: 'Цена по јединици',
        unitPriceHint: 'Са ПДВ-ом (бруто)',
        tireDetails: 'Детаљи гуме',
        tireType: 'Тип гуме',
        tireAction: 'Акција',
        tireSize: 'Димензија',
        tireSizePlaceholder: '205/55R16',
        tireDiameter: 'Пречник (фелне)',
        tireDotCode: 'DOT код (опционо)',
        tireDotCodePlaceholder: '2423',
        tireDotCodeHint: 'Седмица и година производње (нпр. 2423 = 24. седмица 2023)',
        save: 'Сачувај измене',
        add: 'Додај',
        cancel: 'Откажи',
        validationError: 'Молимо исправите следеће грешке:',

        // Validation messages
        fieldRequired: 'Ово поље је обавезно',
        quantityMustBePositive: 'Количина мора бити већа од 0',
        priceMustBeNonNegative: 'Цена мора бити 0 или већа',
      },

      // Tire types
      tireTypes: {
        Summer: 'Летња',
        Winter: 'Зимска',
        AllSeason: 'Целогодишња',
      },

      // Tire actions
      tireActions: {
        Other: 'Остало',
        GroupAction: 'Групна акција',
        Purchase: 'Куповина',
        Replace: 'Замена',
        Storage: 'Складиштење',
        Dispose: 'Отпис',
      },

      // Actions
      actions: {
        viewVehicle: 'Погледај возило',
        edit: 'Измени',
        delete: 'Обриши',
        save: 'Сачувај',
        saving: 'Чување...',
        cancel: 'Откажи',
      },

      // Validation
      validation: {
        vehicleRequired: 'Возило је обавезно',
        odometerRequired: 'Стање километраже је обавезно',
        odometerPositive: 'Стање километраже мора бити позитиван број',
        odometerCannotDecrease: 'Стање километраже не може бити мање од тренутног стања возила ({{current}} км). Унели сте: {{provided}} км',
        descriptionRequired: 'Опис је обавезан',
        descriptionMinLength: 'Опис мора имати најмање 10 карактера',
        itemTypeRequired: 'Тип ставке је обавезан',
        itemDescriptionRequired: 'Опис ставке је обавезан',
        quantityRequired: 'Количина је обавезна',
        quantityPositive: 'Количина мора бити позитиван број',
        unitPriceRequired: 'Цена је обавезна',
        unitPricePositive: 'Цена мора бити позитиван број',
        tireSizeRequired: 'Димензија гуме је обавезна',
        tireDiameterRequired: 'Пречник гуме је обавезан',
        invoiceNumberRequired: 'Број фактуре је обавезан',
        contractRequired: 'Уговор је обавезан када је одабран добављач',
        customProviderNameRequired: 'Назив сервисера је обавезан када добављач није одабран',
        itemsRequired: 'Бар једна ставка је обавезна',
      },

      // Helper texts
      helpers: {
        currentOdometer: 'Тренутно стање: {{odometer}} км',
      },

      // Success messages
      success: {
        created: 'Сервис је успешно креиран',
        updated: 'Сервис је успешно ажуриран',
        deleted: 'Сервис је успешно обрисан',
        itemAdded: 'Ставка је успешно додата',
        itemUpdated: 'Ставка је успешно ажурирана',
        itemDeleted: 'Ставка је успешно обрисана',
      },

      // Error messages
      errors: {
        createFailed: 'Грешка при креирању сервиса',
        updateFailed: 'Грешка при ажурирању сервиса',
        deleteFailed: 'Грешка при брисању сервиса',
        loadFailed: 'Грешка при учитавању сервиса',
        itemAddFailed: 'Грешка при додавању ставке',
        itemUpdateFailed: 'Грешка при ажурирању ставке',
        itemDeleteFailed: 'Грешка при брисању ставке',
      },

      // Dialogs
      deleteConfirmTitle: 'Обриши сервис',
      deleteConfirmMessage: 'Да ли сте сигурни да желите да обришете овај сервис? Ова акција се не може поништити.',
      deleteItemTitle: 'Обриши ставку',
      deleteItemMessage: 'Да ли сте сигурни да желите да обришете ову ставку?',
    },
    providers: {
      title: 'Добављачи',
      subtitle: 'Преглед добављача за возни парк',
      create: 'Нови добављач',
      edit: 'Измени добављача',
      notFound: 'Добављач није пронађен',
      viewAllServiceTypes: 'Прикажи све типове услуга',
      search: 'Претражи добављаче...',
      noResults: 'Нема добављача који одговарају претрази',
      empty: 'Нема добављача',
      fields: {
        name: 'Назив',
        serviceTypes: 'Типови услуга',
        contactEmail: 'Емаил',
        contactPhone: 'Телефон',
        address: 'Адреса',
        taxId: 'ПИБ',
        notes: 'Напомене',
        activeContracts: 'Активни уговори',
      },
      serviceTypes: {
        Service: 'Сервис',
        Repair: 'Поправка',
        Tire: 'Гуме',
        Fuel: 'Гориво',
        Registration: 'Регистрација',
        TechnicalInspection: 'Технички преглед',
        Insurance: 'Осигурање',
        Cleaning: 'Чишћење',
        Other: 'Остало',
      },
      details: {
        info: 'Информације о добављачу',
        contracts: 'Уговори',
        noContracts: 'Нема уговора',
      },
    },
    contracts: {
      title: 'Уговори',
      subtitle: 'Преглед уговора везаних за возни парк',
      create: 'Нови уговор',
      edit: 'Измени уговор',
      notFound: 'Уговор није пронађен',
      search: 'Претражи уговоре...',
      noResults: 'Нема уговора који одговарају претрази',
      empty: 'Нема уговора',
      add: 'Нови уговор',
      number: 'Број уговора',
      type: 'Тип',
      supplier: 'Добављач',
      vehicle: 'Возило',
      startDate: 'Почетак',
      endDate: 'Истек',
      value: 'Вредност',
      status: 'Статус',
      expiringWarning: '{{count}} уговор(а) истиче ускоро',
      expiredWarning: '{{count}} уговор(а) је истекло',
      viewProvider: 'Погледај добављача',
      viewAllScopes: 'Прикажи све обухвате',
      fields: {
        providerId: 'Добављач',
        provider: 'Добављач',
        contractNumber: 'Број уговора',
        scopes: 'Обухват',
        validFrom: 'Важећи од',
        validTo: 'Важећи до',
        contractAmountNet: 'Износ уговора (без ПДВ-а)',
        contractAmountNetShort: 'Износ (НЕТ)',
        vatRate: 'Стопа ПДВ-а',
        contractAmountGross: 'Износ уговора (са ПДВ-ом)',
        contractAmountGrossShort: 'Износ (БРУТО)',
        remainingAmountGrossShort: 'Преостало (БРУТО)',
        contractAmountHint: 'Унесите износ уговора са ПДВ-ом',
        consumedAmountNet: 'Потрошено (НЕТ)',
        consumedAmountGross: 'Потрошено (БРУТО)',
        remainingAmountNet: 'Преостало (НЕТ)',
        remainingAmountGross: 'Преостало (БРУТО)',
        status: 'Статус',
        notes: 'Напомене',
      },
      details: {
        info: 'Информације о уговору',
      },
      scopes: {
        Service: 'Сервис',
        Repair: 'Поправка',
        Tire: 'Гуме',
        Fuel: 'Гориво',
        Registration: 'Регистрација',
        TechnicalInspection: 'Технички преглед',
        Insurance: 'Осигурање',
        Cleaning: 'Чишћење',
        Other: 'Остало',
      },
      statuses: {
        Draft: 'Нацрт',
        Active: 'Активан',
        Expired: 'Истекао',
        Terminated: 'Раскинут',
      },
      expiringSoon: 'Истиче ускоро',
    },
    tireProcurement: {
      title: 'Вулканизерски трошкови',
      subtitle: 'Преглед вулканизерских трошкова за возни парк',
      add: 'Нова набавка',
      inProgress: 'у току',
      activeCount: '{{count}} активна набавка(е) у току',
      number: 'Број набавке',
      vehicle: 'Возило',
      type: 'Тип гуме',
      size: 'Димензија',
      quantity: 'Количина',
      supplier: 'Добављач',
      date: 'Датум',
      price: 'Цена',
      status: 'Статус',
    },
    travelOrders: {
      title: 'Вожње',
      subtitle: 'Преглед и управљање вожњама',
      fields: {
        orderNumber: 'Број вожње',
        vehiclePlateNumber: 'Регистарска ознака',
        purpose: 'Сврха',
        destination: 'Дестинација',
        plannedStartDate: 'Планирани почетак',
        plannedEndDate: 'Планирани завршетак',
        status: 'Статус',
      },
      statuses: {
        Open: 'Отворен',
        InProgress: 'У току',
        Completed: 'Завршен',
        Closed: 'Затворен',
        Cancelled: 'Отказан',
      },
      tabs: {
        my: 'Моје вожње',
        all: 'Све вожње',
        responsible: 'Вожње мојих возила',
        overview: 'Преглед',
        notes: 'Напомене',
        fuelLogs: 'Уноси горива',
        timeline: 'Временска линија',
        odometerCorrections: 'Корекције километраже',
      },
      columns: {
        orderNumber: 'Број вожње',
        vehicle: 'Возило',
        driver: 'Возач',
        period: 'Период',
        status: 'Статус',
        actions: 'Акције',
        km: 'Км',
      },
      filters: {
        plateNumber: 'Регистарска ознака',
        selectVehicle: 'Изаберите возило',
        fromDate: 'Од датума',
        toDate: 'До датума',
      },
      tooltips: {
        view: 'Прегледај',
        startTrip: 'Стартуј вожњу',
        endTrip: 'Заврши вожњу',
      },
      actions: {
        short: {
          start: 'Стартуј',
          end: 'Заврши',
          close: 'Закључи',
        },
      },
      empty: {
        my: 'Немате вожњи',
        responsible: 'Нема вожњи на вашим путним налозима',
        filtered: 'Нема резултата за изабране филтере',
        all: 'Нема вожњи',
        forVehicle: 'Нема вожњи за ово возило.',
      },
      totalCount: 'Укупно: {{count}} вожњи',
      detail: {
        title: 'Вожња - {{number}}',
        loading: 'Учитавање вожње...',
        notFound: 'Вожња није пронађена или је дошло до грешке при учитавању.',
        viewRequest: 'Погледај захтев',
        basicInfo: 'Основне информације',
        tripDetails: 'Детаљи вожње',
        timeline: 'Временски ток',
        closureInfo: 'Информације о затварању/отказивању',
        fuelLogsEmpty: 'Нема унетих података о гориву за ову вожњу.',
        odometerCorrections: 'Историја корекција километраже',
        fields: {
          orderNumber: 'Број вожње',
          vehicle: 'Возило',
          vehicleDescription: 'Опис возила',
          driver: 'Возач',
          startOdometer: 'Почетно стање километраже',
          endOdometer: 'Завршно стање километраже',
          totalDistance: 'Укупна дистанца',
          destination: 'Релација',
          duration: 'Трајање',
          plannedStart: 'Планирани почетак',
          plannedEnd: 'Планирани завршетак',
          actualStart: 'Стварни почетак',
          actualEnd: 'Стварни завршетак',
          startNotes: 'Напомене при почетку',
          endNotes: 'Напомене при завршетку',
          createdAt: 'Креирано',
          startedAt: 'Започето',
          completedAt: 'Завршено',
          closedAt: 'Затворено',
          cancelledAt: 'Отказано',
          startedBy: 'Стартовао',
          endedBy: 'Завршио',
          onBehalfOfDriver: 'уместо возача',
          closedBy: 'Затворио',
          closedAtDate: 'Датум затварања',
          closingNotes: 'Напомене при затварању',
          cancelledAtDate: 'Датум отказивања',
          cancellationReason: 'Разлог отказивања',
        },
        actions: {
          viewVehicle: 'Погледај возило',
          edit: 'Измени',
          startTrip: 'Стартуј вожњу',
          endTrip: 'Заврши вожњу',
          close: 'Закључи вожњу',
          cancel: 'Откажи вожњу',
          correctOdometer: 'Исправи километражу',
        },
      },
      form: {
        createTitle: 'Креирај вожњу',
        editTitle: 'Измени вожњу',
        vehicleAndDriver: 'Возило и возач',
        tripDetails: 'Детаљи путовања',
        vehicle: 'Возило',
        driver: 'Возач',
        destination: 'Релација',
        plannedStartDate: 'Планирани датум почетка',
        plannedEndDate: 'Планирани датум завршетка',
        submitCreate: 'Креирај вожњу',
        submitEdit: 'Сачувај измене',
        editWarning: 'Упозорење:',
        editWarningText: 'Мењате вожњу која је већ {{status}}. Измене могу утицати на извештаје и евиденцију.',
        inProgressInfo: 'Планирани датум почетка је закључан зато што је вожња већ започета. Планирани датум завршетка можете само продужити.',
        completedWarning: 'Ова вожња је завршена или закључена и планирани датуми више не могу да се мењају.',
        validation: {
          startDateRequired: 'Планирани датум почетка је обавезан',
          endDateAfterStart: 'Датум завршетка мора бити након датума почетка',
          startDateLockedInProgress: 'Планирани датум почетка се не може мењати када је вожња у току',
          endDateExtendOnly: 'Планирани датум завршетка се може само продужити када је вожња у току',
          fillRequiredFields: 'Молимо попуните сва обавезна поља',
        },
      },
      odometerConflict: {
        label: 'Одступање километраже',
        tooltip: 'Километража на овој вожњи не уклапа се у редослед очитавања возила. Исправља је возач док вожња није затворена или менаџер вожњи; путни налог се не може затворити док одступање постоји.',
      },
      dialogs: {
        details: {
          title: 'Детаљи вожње:',
          orderNumber: 'Број вожње:',
          vehicle: 'Возило:',
          driver: 'Возач:',
          purpose: 'Сврха:',
          period: 'Период:',
          destination: 'Дестинација:',
          startOdometer: 'Почетна километража:',
          startedAt: 'Започето:',
          totalDistance: 'Пређена дистанца:',
          odometer: 'Километража:',
        },
        start: {
          title: 'Стартуј вожњу',
          description: 'Потврдите да желите да започнете вожњу. Возило ће бити означено као "У употреби".',
          odometerLabel: 'Почетна километража',
          odometerHelper: 'Унесите тренутно стање километраже са инструмент табле возила',
          allowedRange: 'Дозвољени опсег за почетну километражу',
          dateLabel: 'Стварни почетак - датум',
          timeLabel: 'Стварни почетак - време',
          notesLabel: 'Напомене (опционо)',
          notesPlaceholder: 'Нпр. Стање возила, посебне напомене...',
          submit: 'Стартуј вожњу',
          submitting: 'Покретање...',
          validation: {
            dateRequired: 'Датум стварног почетка је обавезан',
            timeRequired: 'Време стварног почетка је обавезно',
            odometerRequired: 'Почетна километража је обавезна',
            odometerPositive: 'Почетна километража мора бити позитиван број',
          },
        },
        end: {
          title: 'Заврши вожњу',
          description: 'Потврдите завршетак вожње. Возило ће бити враћено и доступно за закључивање од стране администратора.',
          odometerLabel: 'Завршна километража',
          odometerPlaceholder: 'Најмање {{value}} km',
          odometerHelper: 'Унесите завршну километражу за ажурирање стања возила',
          allowedRange: 'Дозвољени опсег за завршну километражу',
          dateLabel: 'Стварни завршетак - датум',
          timeLabel: 'Стварни завршетак - време',
          notesLabel: 'Напомене (опционо)',
          notesPlaceholder: 'Нпр. Стање возила, проблеми током путовања...',
          distanceInfo: 'Пређена дистанца:',
          submit: 'Заврши вожњу',
          submitting: 'Завршавање...',
          validation: {
            dateRequired: 'Датум стварног завршетка је обавезан',
            timeRequired: 'Време стварног завршетка је обавезно',
            odometerRequired: 'Завршна километража је обавезна',
            odometerPositive: 'Завршна километража мора бити позитиван број',
            odometerTooLow: 'Завршна километража не може бити мања од {{value}} km',
          },
        },
        cancel: {
          title: 'Откажи вожњу',
          description: 'Молимо унесите разлог отказивања вожње.',
          reasonLabel: 'Разлог отказивања',
          reasonPlaceholder: 'Нпр. Путовање је отказано због промена планова...',
          reasonHelper: 'Минимално 10 карактера',
          submit: 'Откажи вожњу',
          submitting: 'Отказивање...',
          validation: {
            reasonRequired: 'Разлог отказивања је обавезан',
            reasonTooShort: 'Разлог мора имати најмање 10 карактера',
          },
        },
        close: {
          title: 'Закључи вожњу',
          description: 'Потврдите закључивање вожње. Возило ће постати доступно за нове захтеве.',
          notesLabel: 'Напомене (опционо)',
          notesPlaceholder: 'Нпр. Све у реду, вожња затворена...',
          submit: 'Закључи вожњу',
          submitting: 'Закључивање...',
        },
        edit: {
          title: 'Измени вожњу',
          inProgressInfo: 'Вожња је у току: планирани почетак је закључан, а планирани завршетак можете само продужити.',
          completedWarning: 'Завршена или закључена вожња више не може да мења планиране датуме.',
          purposeLabel: 'Сврха',
          purposeHelper: 'Опишите сврху вожње',
          purposePlaceholder: 'Нпр. Службено путовање у Београд',
          plannedPeriod: 'Планирани период',
          startDate: 'Датум почетка *',
          startTime: 'Време почетка',
          endDate: 'Датум завршетка *',
          endTime: 'Време завршетка',
          optional: 'Опционо',
          destinationLabel: 'Релација',
          destinationPlaceholder: 'Нпр. Београд - Нови Сад',
          submit: 'Сачувај измене',
          validation: {
            startLocked: 'Планирани почетак се не може мењати када је вожња у току.',
            endExtendOnly: 'Планирани завршетак се може само продужити када је вожња у току.',
          },
        },
        notes: {
          startTitle: 'Напомене при почетку путовања',
          endTitle: 'Напомене при завршетку путовања',
          closingTitle: 'Напомене при затварању вожње',
          startPlaceholder: 'Унесите напомене при почетку путовања...',
          endPlaceholder: 'Унесите напомене при завршетку путовања...',
          closingPlaceholder: 'Унесите напомене при затварању вожње...',
          charCount: '{{value}}/1000 карактера',
          empty: 'Нема напомена',
          edit: 'Измени напомене',
        },
        correctOdometer: {
          title: 'Исправка километраже вожње',
          description: 'Исправите погрешно унету почетну и/или завршну километражу. Свака вредност мора бити између претходног и следећег очитавања возила.',
          descriptionStartOnly: 'Вожња је у току, па се може исправити само почетна километража. Вредност мора бити између претходног и следећег очитавања возила.',
          endedAt: 'Завршено:',
          startLabel: 'Почетна километража',
          endLabel: 'Завршна километража',
          startRange: 'Дозвољени опсег за почетну километражу',
          endRange: 'Дозвољени опсег за завршну километражу',
          currentValue: 'Тренутно унето: {{value}}',
          reasonHelper: 'Обавезно: зашто се километража исправља',
          correctedInOtherPeriod: 'Исправља се у путном налогу за {{period}}',
          periodNotAvailable: 'Путни налог за {{period}} није отворен или немате овлашћење да исправите ову километражу',
          submit: 'Сачувај исправку',
          validation: {
            endBelowStart: 'Завршна километража не може бити мања од почетне',
            noChanges: 'Нисте променили ниједну вредност километраже',
          },
        },
      },
    },
    travelOrderPeriods: {
      title: 'Путни налози',
      subtitle: 'Преглед и управљање путним налозима',
      loadError: 'Грешка при учитавању путног налога',
      noAccess: 'Овај путни налог вам више није доступан.',
      detailTitle: 'Путни налог - {{number}}',
      statuses: {
        Open: 'Отворен',
        Closed: 'Затворен',
        Cancelled: 'Отказан',
      },
      tabs: {
        my: 'Моји путни налози',
        all: 'Сви путни налози',
        trips: 'Вожње',
        fuelLogs: 'Уноси горива',
        holderHistory: 'Историја носилаца',
        odometerCorrections: 'Корекције километраже',
      },
      columns: {
        orderNumber: 'Број налога',
        vehicle: 'Возило',
        period: 'Период',
        responsiblePerson: 'Носилац налога',
        trips: 'Вожње',
        status: 'Статус',
        actions: 'Акције',
      },
      filters: {
        vehicle: 'Возило',
        selectVehicle: 'Изаберите возило',
        fromDate: 'Од датума',
        toDate: 'До датума',
        status: 'Статус',
        allStatuses: 'Сви статуси',
        active: 'Активни',
      },
      empty: {
        filtered: 'Нема резултата за изабране филтере',
        all: 'Нема путних налога',
      },
      badges: {
        active: 'Активни',
        odometerConflicts: 'Одступања: {{count}}',
      },
      actions: {
        close: 'Затвори налог',
        edit: 'Уреди',
        reopen: 'Поново отвори',
        changeHolder: 'Промени носиоца',
        downloadPdf: 'Преузми PDF',
        generatingPdf: 'Генерисање PDF...',
        addTrip: 'Додај вожњу',
        enterOdometer: 'Унеси километражу',
      },
      info: {
        title: 'Информације о путном налогу',
        orderNumber: 'Број налога',
        period: 'Период',
        vehicle: 'Возило',
        responsiblePerson: 'Носилац налога',
        tripCount: 'Број вожњи',
        startOdometer: 'Почетно стање км',
        endOdometer: 'Крајње стање км',
        totalDistance: 'Укупна километража',
        odometerConflictCount: 'Вожње са одступањем',
        createdAt: 'Креирано',
        closedAt: 'Затворено',
        closedBy: 'Затворио',
        cancelledAt: 'Отказано',
        cancellationReason: 'Разлог отказивања',
      },
      holderHistory: {
        title: 'Историја носилаца путног налога',
        date: 'Датум',
        fromHolder: 'Претходни носилац',
        toHolder: 'Нови носилац',
        changedBy: 'Променио',
        reason: 'Разлог',
      },
      tripsTab: {
        title: 'Вожње у путном налогу',
        empty: 'Нема вожњи у овом путном налогу',
        conflictsOnly: 'Само са одступањем',
        continuation: 'Наставак из претходног месеца',
        continuesNextMonth: 'Наставља се у следећем месецу',
        distanceThisMonth: 'У овом месецу: {{start}} → {{end}} ({{distance}})',
        distanceWholeTrip: 'Цела вожња: {{start}} → {{end}} ({{distance}})',
        columns: {
          orderNumber: 'Број налога',
          status: 'Статус',
          driver: 'Возач',
          plannedPeriod: 'Планирани период',
          destination: 'Релација',
          distance: 'Км у месецу',
        },
      },
      fuelLogsTab: {
        title: 'Уноси горива',
        empty: 'Нема унетих података о гориву за овај период.',
        relink: 'Повежи гориво',
        relinkHint: 'Поново повеже свако сипање са вожњом у чијем је времену обављено. Безбедно за понављање.',
        relinkChanged: 'Проверено {{examined}} уноса, промењено {{changed}}.',
        relinkUnchanged: 'Проверено {{examined}} уноса, све везе су већ биле исправне.',
      },
      distance: {
        trips: 'Вожње',
        unallocated: 'Нераспоређено',
        unallocatedTooltip: 'Разлика између километраже по бројачу (крајње − почетно стање) и збира километара вожњи у овом месецу. Код додељених возила је уобичајена, а код возила из пула значи да недостаје вожња.',
      },
      odometerCorrectionsTab: {
        title: 'Историја корекција километраже',
      },
      dialogs: {
        details: {
          title: 'Детаљи путног налога:',
          orderNumber: 'Број налога:',
          period: 'Период:',
          vehicle: 'Возило:',
          responsiblePerson: 'Носилац налога:',
          tripCount: 'Број вожњи:',
          startOdometer: 'Почетна километража:',
          tripsDistance: 'Км у вожњама:',
          enteredEndOdometer: 'Крајње стање које је унео носилац:',
          closedBy: 'Затворио:',
        },
        close: {
          title: 'Затвори путни налог',
          description: 'Да ли сте сигурни да желите да затворите овај путни налог? Након затварања нећете моћи додавати нове вожње у овај путни налог.',
          finalOdometerLabel: 'Завршна километража (опционо)',
          defaultEntered: 'Ако поље оставите празно, налог се затвара са крајњим стањем које је унео носилац ({{value}}).',
          defaultDerived: 'Ако поље оставите празно, користи се последње очитавање возила у овом месецу, а ако га нема, почетно стање налога ({{value}}).',
          missingMileageWarning: 'Носилац није унео километражу за овај месец, а у налогу нема вожњи. Унесите крајње стање бројача сада; оно постаје километража налога.',
          odometerConflicts: 'Налог има вожњи са одступањем километраже: {{count}}. Исправите их пре затварања.',
          overrideReasonLabel: 'Разлог промене унете километраже',
          overrideReasonHelper: 'Обавезно: вредност се разликује од стања које је унео носилац ({{value}})',
          finalOdometerHelper: 'Опционо: стање бројача на крају месеца. Мора бити у дозвољеном опсегу.',
          submit: 'Затвори путни налог',
          submitting: 'Затварање...',
        },
        cancel: {
          title: 'Откажи путни налог',
          description: 'Молимо унесите разлог отказивања путног налога.',
          reasonLabel: 'Разлог отказивања',
          reasonPlaceholder: 'Нпр. Путни налог је отказан због промене планова...',
          reasonHelper: 'Минимално 10 карактера',
          submit: 'Откажи путни налог',
          submitting: 'Отказивање...',
          validation: {
            reasonRequired: 'Разлог отказивања је обавезан',
            reasonTooShort: 'Разлог мора имати најмање 10 карактера',
          },
        },
        reopen: {
          title: 'Поново отвори путни налог',
          overlapWarning: 'Овај путни налог се не може поново отворити јер постоји други активан (отворен) путни налог за исто возило који се преклапа са овим периодом. Прво затворите или откажите преклапајући путни налог.',
          description: 'Да ли сте сигурни да желите поново да отворите овај путни налог? Након отварања моћи ћете додавати нове вожње и мењати податке периода.',
          submit: 'Поново отвори',
          submitting: 'Отварање...',
        },
        edit: {
          title: 'Уреди путни налог',
          cancelledWarning: 'Отказани путни налог се не може уређивати.',
          odometerSection: 'Стање километраже',
          startOdometerLabel: 'Почетно стање (km)',
          startOdometerHelper: 'Може се мењати само на првом путном налогу возила и не сме бити веће од првог евидентираног очитавања',
          holderFirstPeriodInfo: 'Почетно стање уноси се само за први путни налог возила; сваки следећи преузима крај претходног. Унето стање постаје стање возила.',
          endOdometerInfo: 'Крајње стање: {{value}}',
          endOdometerPlaceholder: 'Није постављено',
          totalDistance: 'Укупна километража: {{value}} km',
          reasonHelper: 'Обавезно: зашто се мења почетно стање',
          submit: 'Сачувај измене',
          submitting: 'Чување...',
          validation: {
            startOdometerNegative: 'Почетно стање km не може бити негативно',
            noChanges: 'Нема промена за чување',
          },
        },
        changeHolder: {
          title: 'Промени носиоца путног налога',
          orderLabel: 'Путни налог:',
          currentHolder: 'Тренутни носилац:',
          newHolderLabel: 'Нови носилац',
          reasonLabel: 'Разлог промене',
          reasonPlaceholder: 'Нпр. Годишњи одмор тренутног носиоца...',
          optional: 'Опционо',
          submit: 'Промени носиоца',
          submitting: 'Промена...',
          validation: {
            newHolderRequired: 'Нови носилац је обавезан',
          },
        },
        createTrip: {
          title: 'Додај вожњу',
          description: 'Креирање вожње у путном налогу:',
          driverLabel: 'Возач',
          holderAsDriverInfo: 'Вожња се креира са вама као возачем. Вожњу за другог возача поднесите као захтев за возило.',
          startDate: 'Датум почетка *',
          startTime: 'Време почетка',
          endDate: 'Датум завршетка',
          endTime: 'Време завршетка',
          optional: 'Опционо',
          destinationLabel: 'Релација',
          submit: 'Креирај вожњу',
          submitting: 'Креирање...',
          validation: {
            driverRequired: 'Возач је обавезан',
            startDateRequired: 'Датум почетка је обавезан',
          },
        },
        enterOdometer: {
          title: 'Унос километраже на путни налог',
          description: 'Унесите стање бројача возила на крају месеца. Пређени километри налога рачунају се као разлика крајњег и почетног стања.',
          enteredValue: 'Унето крајње стање:',
          allowedRange: 'Дозвољени опсег на крају месеца',
          rangeNote: 'Границе су очитавања возила непосредно пре и после краја месеца.',
          earlyEntryWarning: 'Месец још није при крају. Унета вредност постаје горња граница за све вожње овог месеца после данашњег дана, а стање возила је одмах приказује. Унесите километражу на крају месеца, осим ако се возило овог месеца више неће користити.',
          endOdometerLabel: 'Крајње стање километраже',
          endOdometerHelper: 'Стање бројача на последњи дан месеца',
          totalDistance: 'Укупно пређено у налогу:',
          reasonHelper: 'Обавезно при измени већ унете вредности',
          submit: 'Сачувај километражу',
          validation: {
            belowStart: 'Крајње стање не може бити мање од почетног ({{value}})',
            noChanges: 'Унета вредност је иста као постојећа',
          },
        },
      },
    },
    odometer: {
      reasonLabel: 'Разлог исправке',
      readingKinds: {
        TripStart: 'почетак вожње',
        TripEnd: 'крај вожње',
        PeriodEnd: 'крај путног налога',
        VehicleCorrection: 'ручна корекција возила',
      },
      bounds: {
        previous: 'Претходно очитавање (најмање)',
        next: 'Следеће очитавање (највише)',
        initialOdometer: 'Почетно стање возила (најмање)',
        none: 'нема',
        range: 'од {{from}} до {{to}}',
        loading: 'Учитавање дозвољеног опсега...',
        loadError: 'Дозвољени опсег није могуће учитати. Вредност ће проверити сервер при чувању.',
        dependsOnMoment: 'Опсег зависи од унетог датума и времена и освежава се када их промените.',
      },
      chainWarning: {
        belowPrevious: 'Унета вредност одступа од претходног очитавања ({{value}}). Унесите стварно стање бројача и објасните у напомени; менаџер вожњи ће ускладити.',
        aboveNext: 'Унета вредност одступа од следећег очитавања ({{value}}). Унесите стварно стање бројача и објасните у напомени; менаџер вожњи ће ускладити.',
        belowInitial: 'Унета вредност одступа од почетног стања возила ({{value}}). Унесите стварно стање бројача и објасните у напомени; менаџер вожњи ће ускладити.',
      },
      validation: {
        required: 'Унесите стање километраже',
        invalid: 'Километража мора бити ненегативан цео број',
        belowPrevious: 'Вредност не може бити мања од претходног очитавања ({{value}})',
        aboveNext: 'Вредност не може бити већа од следећег очитавања ({{value}})',
        reasonRequired: 'Разлог је обавезан',
        reasonTooLong: 'Разлог не може бити дужи од {{max}} карактера',
      },
      corrections: {
        empty: 'Нема корекција километраже',
        loadError: 'Грешка при учитавању историје корекција километраже',
        columns: {
          date: 'Датум',
          target: 'Исправљено на',
          field: 'Поље',
          change: 'Старо → ново',
          reason: 'Разлог',
          correctedBy: 'Исправио',
          status: 'Статус',
          actions: 'Акције',
        },
        fields: {
          Start: 'Почетна километража',
          End: 'Завршна километража',
          Current: 'Стање возила',
        },
        targetTypes: {
          Trip: 'Вожња',
          TravelOrderPeriod: 'Путни налог',
          Vehicle: 'Возило',
        },
        active: 'Важећа',
        voided: 'Сторнирана',
        voidReason: 'Разлог сторна',
        voidAction: 'Сторнирај',
      },
      void: {
        title: 'Сторнирање корекције километраже',
        description: 'Сторнирате ручну корекцију возила на {{value}} од {{date}}. Сторнирана корекција више не учествује у ланцу очитавања, а стање возила се поново израчунава.',
        reasonLabel: 'Разлог сторна',
        reasonHelper: 'Обавезно: зашто је корекција била погрешна',
        submit: 'Сторнирај',
        submitting: 'Сторнирање...',
      },
    },
    trips: {
      title: 'Вожње',
    },
    reports: {
      title: 'Извештаји',
      sections: {
        Identification: 'Идентификација',
        OperationalUnit: 'Транспортна јединица',
        Engine: 'Мотор и техника',
        Registration: 'Регистрација',
        Assignment: 'Додела',
        Blocks: 'Блокаде',
        Service: 'Сервис',
        Vulcanizer: 'Вулканизер',
        Tires: 'Гуме',
      },
      dialog: {
        openButton: 'Извештај (Excel)',
        title: 'Извештај о возилима',
        subtitle: 'Изаберите колоне и опсег, проверите преглед и преузмите Excel фајл.',
        columns: 'Колоне',
        preset: 'Основни сет',
        clear: 'Очисти',
        settings: 'Опсег и подешавања',
        reportName: 'Назив извештаја',
        reportNamePlaceholder: 'нпр. Возила – регистрација истиче',
        units: 'Транспортне јединице',
        unitsHelp: 'Празно = све јединице које су вам доступне.',
        asOfDate: 'Датум пресека',
        asOfDateHelp: 'За старост, важење регистрације, активне доделе и блокаде.',
        sortBy: 'Сортирање',
        sortDefault: 'Подразумевано (јединица, интерни број)',
        asc: 'Растуће',
        desc: 'Опадајуће',
        preview: 'Преглед',
        previewAction: 'Преглед',
        previewHint: 'Приказано првих {{count}} редова.',
        totalVehicles: 'Укупно возила: {{count}}',
        noRows: 'Нема возила која одговарају изабраном опсегу.',
        export: 'Преузми Excel',
        summaryColumns: '{{count}} колона',
        summaryUnits: '{{count}} јединица',
        summaryAllUnits: 'све доступне јединице',
        summaryAsOf: 'пресек {{date}}',
      },
      templates: {
        title: 'Шаблони',
        load: 'Учитај шаблон',
        none: 'Без шаблона',
        sharedShort: 'Дељен',
        update: 'Сачувај измене у шаблон',
        saveAs: 'Сачувај као нови шаблон',
        delete: 'Обриши шаблон',
        saveTitle: 'Сачувај шаблон',
        name: 'Назив шаблона',
        visibility: {
          Private: 'Само ја',
          Shared: 'Дељен са тимом возног парка',
        },
        deleteConfirm: 'Обрисати шаблон „{{name}}“?',
        loadError: 'Шаблон није могуће учитати.',
        saveError: 'Шаблон није могуће сачувати.',
        deleteError: 'Шаблон није могуће обрисати.',
      },
    },
    requests: {
      title: 'Захтеви за измене',
      subtitle: 'Преглед и одобравање захтева за измене возила',
      pendingCount: '{{count}} захтев(а) чека одобрење',
      noRequests: 'Нема захтева',
      vehicle: 'Возило',
      type: 'Тип',
      field: 'Поље',
      oldValue: 'Стара вредност',
      newValue: 'Нова вредност',
      submittedBy: 'Подносилац',
      date: 'Датум',
      status: 'Статус',
      approve: 'Одобри',
      reject: 'Одбиј',
    },
    vehicleRequests: {
      title: 'Захтеви за возила',
      subtitle: 'Преглед и управљање захтевима за коришћење возила',
      create: 'Нови захтев',
      add: 'Нови захтев',
      details: 'Детаљи захтева',
      loading: 'Учитавање захтева...',
      notFound: 'Захтев није пронађен или је дошло до грешке при учитавању.',

      // Tabs
      tabs: {
        all: 'Сви захтеви',
        allMine: 'За возила која одобравам',
        my: 'Моји захтеви',
        pending: 'На чекању',
        pendingMine: 'На чекању (за моје одобрење)',
      },
      table: {
        notAssigned: 'Није додељено',
      },
      tooltips: {
        view: 'Прегледај',
        approve: 'Одобри',
        reject: 'Одбиј',
      },

      // Table columns
      columns: {
        vehicle: 'Возило',
        purpose: 'Сврха',
        period: 'Период',
        requester: 'Подносилац',
        status: 'Статус',
        actions: 'Акције',
      },

      // Form
      form: {
        title: 'Нови захтев за возило',
        subtitle: 'Попуните форму да бисте затражили возило за одређену сврху',
        vehicleSelection: 'Одабир возила',
        purposeSection: 'Сврха захтева',
        periodSection: 'Период и дестинација',
        periodUsage: 'Период коришћења',
        additionalInfo: 'Додатне информације',
        notesSection: 'Додатне напомене',
        preselectedVehicle: 'Возило је већ одабрано:',
        selectVehicle: 'Одаберите возило',
        vehicleOptional: 'Возило (опционо)',
        vehicleAssignableLater: 'Возило може бити додељено касније од стране менаџера',
        requestForLabel: 'Захтев у име (опционо)',
        requestForSelf: 'За себе',
        requestForHint: 'Одабрани радник ће бити возач на путном налогу након одобрења',
        purposeRequired: 'Сврха *',
        purposeHint: 'Опишите сврху коришћења возила (минимум 10 карактера)',
        purposeHintShort: 'Опишите сврху коришћења возила',
        purposePlaceholder: 'Нпр. Службено путовање у Београд - састанак са клијентом',
        purposePlaceholderShort: 'Нпр. Службено путовање у Београд',
        startDateRequired: 'Датум почетка *',
        endDateRequired: 'Датум завршетка *',
        startTime: 'Време почетка',
        startTimeRequired: 'Време почетка *',
        startTimeFormOptional: 'Време почетка (опционо)',
        endTime: 'Време завршетка',
        endTimeFormOptional: 'Време завршетка (опционо)',
        timeRequiredToday: 'Обавезно када је датум данас',
        timeOptional: 'Опционо',
        timeOptionalFullDay: 'Оставите празно за цео дан',
        destinationOptional: 'Дестинација (опционално)',
        destinationPlaceholder: 'Нпр. Београд, Србија',
        destinationPlaceholderShort: 'Нпр. Београд',
        estimatedKm: 'Процењена км',
        estimatedKmLabel: 'Процењена километража (км)',
        estimatedDistancePlaceholder: 'Нпр. 250',
        estimatedKmPlaceholderShort: 'Нпр. 150',
        notesOptional: 'Напомене (опционално)',
        notesPlaceholder: 'Додатне напомене или захтеви...',
        notesPlaceholderDialog: 'Додатне информације...',
        notesPlaceholderForm: 'Додатне информације о захтеву...',
        editTitle: 'Измени захтев за возило',
        saveChanges: 'Сачувај измене',
        submit: 'Пошаљи захтев',
        submitting: 'Слање...',
        submittingRequest: 'Слање захтева...',
      },

      // Fields
      fields: {
        vehicle: 'Возило',
        vehiclePlateNumber: 'Регистарска ознака',
        vehicleDescription: 'Опис возила',
        requester: 'Подносилац захтева',
        createdBy: 'Захтев поднео',
        purpose: 'Сврха',
        destination: 'Дестинација',
        estimatedDistance: 'Процењена дистанца',
        requestedStartDate: 'Датум почетка',
        requestedEndDate: 'Датум завршетка',
        startDate: 'Датум почетка',
        endDate: 'Датум завршетка',
        duration: 'Трајање',
        notes: 'Напомене',
        status: 'Статус',
        approver: 'Одобрио',
        approvalDate: 'Датум одобрења',
        rejectionDate: 'Датум одбијања',
        rejectionReason: 'Разлог одбијања',
        cancellationDate: 'Датум отказивања',
        cancellationReason: 'Разлог отказивања',
        createdAt: 'Креирано',
        travelOrder: 'Вожња',
      },

      // Statuses
      statuses: {
        pending: 'На чекању',
        approved: 'Одобрен',
        rejected: 'Одбијен',
        cancelled: 'Отказан',
        completed: 'Завршен',
      },

      // Sections
      sections: {
        summary: 'Преглед захтева',
        details: 'Детаљи захтева',
        decision: 'Информације о одлуци',
        timeline: 'Временска линија',
      },

      // Actions
      actions: {
        approve: 'Одобри',
        reject: 'Одбиј',
        cancel: 'Откажи',
        view: 'Прегледај',
        viewVehicle: 'Погледај возило',
      },

      // Dialogs
      dialogs: {
        approveTitle: 'Одобри захтев за возило',
        approveMessage: 'Да ли сте сигурни да желите да одобрите овај захтев?',
        approveDetails: 'Детаљи захтева:',
        approveConfirm: 'Одобри захтев',
        approveConfirming: 'Одобравање...',
        approveSuccess: 'Захтев је успешно одобрен',

        rejectTitle: 'Одбиј захтев за возило',
        rejectMessage: 'Молимо унесите разлог одбијања захтева.',
        rejectDetails: 'Детаљи захтева:',
        rejectReason: 'Разлог одбијања',
        rejectReasonPlaceholder: 'Нпр. Возило је већ резервисано за тај период...',
        rejectReasonHint: 'Минимално 10 карактера',
        rejectConfirm: 'Одбиј захтев',
        rejectConfirming: 'Одбијање...',
        rejectSuccess: 'Захтев је успешно одбијен',

        cancelTitle: 'Откажи захтев за возило',
        cancelMessage: 'Молимо унесите разлог отказивања захтева.',
        cancelDetails: 'Детаљи захтева:',
        cancelReason: 'Разлог отказивања',
        cancelReasonPlaceholder: 'Нпр. Путовање је отказано због промена планова...',
        cancelReasonHint: 'Минимално 10 карактера',
        cancelConfirm: 'Откажи захтев',
        cancelConfirming: 'Отказивање...',
        cancelSuccess: 'Захтев је успешно отказан',
        cancelDisabledTooltip: 'Одобрени захтеви не могу бити отказани. Молимо откажите вожњу уместо тога.',

        assignTitle: 'Додели возило захтеву',
        assignPurpose: 'Сврха захтева:',
        assignAlreadyHasVehicle: 'Овај захтев већ има додељено возило. Одабиром новог возила ће се заменити постојеће.',
        assignVehicleHelper: 'Приказана су само доступна возила',
        assignDriverPrefix: 'Возач',
        assignFreeStatus: 'Слободно',
        assignNoVehiclesAvailable: 'Нема доступних возила за доделу. Сва возила су или заузета или ван употребе.',
        assignError: 'Грешка при додели возила. Покушајте поново.',
        assignConfirm: 'Додели возило',
      },

      // Detail page
      detail: {
        title: 'Захтев за возило',
        notYetAssigned: 'Возило још није додељено овом захтеву. Менаџер може доделити возило кликом на дугме "Додели возило".',
        changeVehicle: 'Промени возило',
        assignVehicle: 'Додели возило',
        timeline: 'Временски ток',
        timelineApproved: 'Одобрено',
        timelineRejected: 'Одбијено',
        timelineCancelled: 'Отказано',
        timelineCompleted: 'Завршено',
        travelOrderLabel: 'Вожња',
        showTravelOrder: 'Прикажи',
      },

      // Messages
      messages: {
        period: 'Период',
        days: 'дана',
        day: 'дан',
        km: 'км',
        travelOrderCreated: 'Вожња је креирана за овај захтев. ID: {{id}}',
      },

      // Упозорења о регистрацији (не блокирају одобравање)
      registrationWarning: {
        missing: 'Возило нема евидентирану важећу регистрацију. Захтев можете одобрити, али регистрацију треба средити пре поласка.',
        expiresBeforeEnd: 'Регистрација возила истиче {{validTo}}, пре краја траженог периода. Захтев можете одобрити, али регистрацију треба обновити.',
        startsAfterStart: 'Регистрација возила важи тек од {{validFrom}}, после почетка траженог периода. Захтев можете одобрити, али возило до тада није регистровано.',
      },

      // Validation
      validation: {
        vehicleRequired: 'Возило је обавезно',
        purposeRequired: 'Сврха је обавезна',
        purposeMinLength: 'Сврха мора имати најмање 10 карактера',
        startDateRequired: 'Датум почетка је обавезан',
        endDateRequired: 'Датум завршетка је обавезан',
        startDateTodayOrFuture: 'Датум почетка мора бити данас или у будућности',
        endDateAfterStartDate: 'Датум завршетка мора бити после датума почетка',
        estimatedDistancePositive: 'Процењена километража мора бити позитиван број',
        reasonRequired: 'Разлог је обавезан',
        reasonMinLength: 'Разлог мора имати најмање 10 карактера',
        timeRequiredToday: 'Време је обавезно када је датум данас',
        timeMustBeFuture: 'Време мора бити у будућности',
      },
    },
    registrations: {
      title: 'Регистрације',
      subtitle: 'Преглед и управљање регистрацијама возила',
      create: 'Нова регистрација',
      createRegistration: 'Нова регистрација',
      editRegistration: 'Измени регистрацију',
      noRegistrations: 'Нема регистрација',
      notFound: 'Регистрација није пронађена',
      loading: 'Учитавање регистрације...',
      costPending: 'Без трошкова',
      generalInfo: 'Општи подаци',
      costInfo: 'Подаци о трошковима',
      providerInfo: 'Информације о провајдеру',
      additionalInfo: 'Додатне информације',
      fields: {
        vehicle: 'Возило',
        validFrom: 'Важи од',
        validTo: 'Важи до',
        registrationDate: 'Датум регистрације',
        registrationExpiry: 'Истек регистрације',
        registrationNumber: 'Број саобраћајне',
        odometerReading: 'Километража',
        cost: 'Трошак',
        invoiceNumber: 'Број фактуре',
        provider: 'Провајдер',
        contract: 'Уговор',
        customProviderName: 'Назив провајдера',
        description: 'Опис',
        notes: 'Напомене',
        updateVehicleRegistration: 'Ажурирај регистрацију возила',
      },
      notesPlaceholder: 'Опционе напомене...',
      columns: {
        vehiclePlate: 'Регистарска ознака',
        validFrom: 'Важи од',
        expiryDate: 'Датум истека',
        cost: 'Трошак',
        provider: 'Добављач',
        status: 'Статус',
      },
      filters: {
        vehicle: 'Возило',
        provider: 'Добављач',
        status: 'Статус',
        dateFrom: 'Датум од',
        dateTo: 'Датум до',
      },
      details: {
        basicInfo: 'Основни подаци',
        vehicleDetails: 'Детали возила',
        providerInfo: 'Информације о добављачу/уговору',
        costDetails: 'Детали трошкова',
        notes: 'Напомене',
        vehiclePlate: 'Регистарска ознака',
        validFrom: 'Важи од',
        validTo: 'Важи до',
        registrationDate: 'Датум регистрације',
        expiryDate: 'Датум истека',
        status: 'Статус',
        description: 'Опис',
        odometerReading: 'Километража',
        registrationNumber: 'Број саобраћајне',
        vehicleId: 'ID возила',
        providerName: 'Назив добављача',
        providerId: 'ID добављача',
        contractNumber: 'Број уговора',
        totalCost: 'Укупан трошак',
        invoiceNumber: 'Број фактуре',
      },
      deleteConfirmTitle: 'Потврда брисања регистрације',
      deleteConfirmMessage: 'Да ли сте сигурни да желите да обришете регистрацију: {{registrationInfo}}?',

      deleteSuccess: 'Регистрација је успешно обрисана',
      deleteError: 'Грешка при брисању регистрације',

      // Status labels
      status: {
        Valid: 'Важећа',
        ExpiringSoon: 'Истиче ускоро',
        Expired: 'Истекла',
        Unknown: 'Непознато',
      },

      // Actions
      actions: {
        view: 'Прегледај',
        edit: 'Измени',
        delete: 'Обриши',
        create: 'Креирај',
      },

      validation: {
        vehicleRequired: 'Возило је обавезно',
        validFromRequired: 'Датум почетка важења је обавезан',
        validToRequired: 'Датум истека важења је обавезан',
        odometerRequired: 'Километража је обавезна',
        odometerNonNegative: 'Километража не може бити негативна',
        costRequired: 'Трошак је обавезан',
        costNonNegative: 'Трошак не може бити негативан',
        descriptionRequired: 'Опис је обавезан',
        contractRequired: 'Уговор је обавезан када је одабран добављач',
      },

      // Success messages
      success: {
        created: 'Регистрација је успешно креирана',
        updated: 'Регистрација је успешно ажурирана',
        deleted: 'Регистрација је успешно обрисана',
      },

      // Error messages
      errors: {
        createFailed: 'Грешка при креирању регистрације',
        updateFailed: 'Грешка при ажурирању регистрације',
        deleteFailed: 'Грешка при брисању регистрације',
        loadFailed: 'Грешка при учитавању регистрације',
      },
    },
    fuelLogs: {
      title: 'Евиденција горива',
      add: 'Додај унос горива',
      edit: 'Измени унос горива',
      withoutTravelOrder: 'Без вожње',
      viewTrip: 'Погледај вожњу',
      viewTravelOrder: 'Погледај путни налог',
      sectionTrip: 'Вожња',
      sectionTravelOrder: 'Путни налог',
      tripNumber: 'Број вожње',
      travelOrderNumber: 'Број путног налога',
      notLinked: 'Није повезан',
      list: {
        title: 'Гориво',
        subtitle: 'Преглед свих уноса горива',
        searchPlaceholder: 'Претражи по возилу, станици, путном налогу...',
        allTypes: 'Сви типови',
        emptyMessage: 'Нема унетих података о гориву.',
        errorMessage: 'Грешка при учитавању података о гориву.',
        importButton: 'Увоз из Excel-а',
        filters: {
          vehicle: 'Возило',
          vehiclePlaceholder: 'Изаберите возило',
          fromDate: 'Од датума',
          toDate: 'До датума',
          productType: 'Тип производа',
          productTypePlaceholder: 'Изаберите тип производа',
          fuelType: 'Тип горива',
          fuelTypePlaceholder: 'Изаберите тип горива',
        },
      },
      summary: {
        vehicleLifetime: 'Укупно за возило',
        lifetimeSubtitle: 'Све време',
        currentMonth: 'Текући месец',
        currentMonthFleet: 'Текући месец (цела флота)',
        filtered: 'Филтрирано',
        totalCost: 'Укупни трошкови',
        totalLiters: 'Укупно литара',
        count: 'Број уноса',
        averageCost: 'Просечан трошак',
      },
      table: {
        vehicle: 'Возило',
        travelOrder: 'Путни налог',
        odometer: 'Километража',
        pricePerLiter: 'Цена/L',
        total: 'Укупно',
        station: 'Станица',
        noOrder: 'Без налога',
        distance: 'Пређено',
        consumption: 'Потрошња',
      },
      consumption: {
        title: 'Анализа потрошње',
        distance: 'Пређено од претходног точења',
        consumption: 'Потрошња',
        status: 'Статус',
        deviation: 'Одступање од референце',
        reference: 'Референтна потрошња возила',
        tolerance: 'Толеранција',
        previousFuelLog: 'Претходно точење',
        viewPrevious: 'Отвори претходно',
        notAvailable: 'Није доступно (прво точење, недостају подаци или возило нема дефинисану референтну потрошњу).',
        noReference: 'Возило нема дефинисану референтну потрошњу, па се статус не рачуна.',
        statuses: {
          Unknown: 'Непознато',
          Normal: 'У границама',
          High: 'Повишена',
          Low: 'Ниска',
        },
      },
      delete: {
        title: 'Потврда брисања',
        message: 'Да ли сте сигурни да желите да обришете унос горива: {{info}}?',
      },
      fuelTypes: {
        Other: 'Остало',
        Diesel: 'Дизел',
        Petrol: 'Бензин',
        LPG: 'ТНГ',
        CNG: 'КПГ',
        Electric: 'Електрично',
      },
      productTypes: {
        Fuel: 'Гориво',
        AdBlue: 'AdBlue',
        Other: 'Остало (није гориво)',
      },
      unitLabels: {
        Liter: 'Литар',
        Piece: 'Комад',
      },
      unitShort: {
        Liter: 'Л',
        Piece: 'КОМ',
      },
      detail: {
        title: 'Унос горива - {{date}}',
        notFound: 'Унос горива није пронађен или је дошло до грешке при учитавању.',
        view: 'Погледај',
        sections: {
          basicInfo: 'Основни подаци',
          providerContract: 'Добављач и уговор',
          additional: 'Додатни детаљи',
          entryInfo: 'Информације о уносу',
        },
        fields: {
          odometer: 'Километража',
          product: 'Производ',
          pricePerUnit: 'Цена по јединици',
          totalCost: 'Укупан трошак',
          provider: 'Добављач',
          contractNumber: 'Број уговора',
          addedBy: 'Унео',
          addedAt: 'Датум уноса',
        },
      },
      fields: {
        vehicle: 'Возило',
        date: 'Датум',
        odometerReading: 'Стање километраже',
        productType: 'Тип производа',
        unit: 'Јединица мере',
        fuelType: 'Тип горива',
        liters: 'Литара',
        quantity: 'Количина',
        pricePerLiter: 'Цена по јединици (RSD)',
        totalCost: 'Укупан трошак (RSD)',
        product: 'Производ',
        productName: 'Назив производа',
        productSku: 'Шифра производа',
        fuelStationName: 'Бензинска станица',
        fuelStationCode: 'Шифра станице',
        fuelCardNumber: 'Број картице',
        invoiceNumber: 'Број фактуре',
        fiscalReceiptNumber: 'Број фискалног рачуна',
        deliveryNoteNumber: 'Број отпремнице',
        notes: 'Напомене',
      },
      import: {
        title: 'Увоз евиденције горива',
        subtitle: 'Учитајте Excel извештај NIS картице и унесите све трансакције одједном.',
        selectFile: 'Изабери фајл',
        changeFile: 'Промени фајл',
        noFileSelected: 'Ниједан фајл није изабран.',
        previewButton: 'Анализирај фајл',
        commitButton: 'Увези изабране редове',
        back: 'Назад',
        cancel: 'Одустани',
        close: 'Затвори',
        fileAccept: 'Подржани формати: .xlsx',
        previewing: 'Анализа у току…',
        committing: 'Увоз у току…',
        previewError: 'Грешка при анализи фајла. Проверите формат и покушајте поново.',
        commitError: 'Грешка при увозу. Ниједан ред није сачуван.',
        dropZoneHint: 'Превуците Excel фајл овде',
        invalidFileType: 'Дозвољен је само .xlsx фајл.',
        summary: {
          totalRows: 'Укупно редова: {{count}}',
          new: 'Нови: {{count}}',
          warning: 'Упозорења: {{count}}',
          duplicate: 'Дупликати: {{count}}',
          invalid: 'Невалидни: {{count}}',
          totalCost: 'Укупан трошак: {{amount}}',
          selected: 'За увоз: {{count}}',
        },
        statuses: {
          New: 'Нови',
          Warning: 'Упозорење',
          Duplicate: 'Дупликат',
          Invalid: 'Невалидан',
        },
        columns: {
          include: 'Увези',
          row: 'Ред',
          status: 'Статус',
          date: 'Датум',
          vehicle: 'Возило',
          product: 'Производ',
          quantity: 'Количина',
          unit: 'Јед.',
          totalCost: 'Укупно',
          odometer: 'Километража',
          travelOrder: 'Путни налог',
        },
        messages: {
          emptyRows: 'Фајл не садржи ниједан ред са подацима.',
          includeDuplicateHint: 'Означите „Увези“ да бисте ажурирали постојећи ред (овер-рајд).',
          invalidCannotImport: 'Невалидни редови се не могу увести.',
          odometerRequired: 'Километража је обавезна.',
          odometerRange: 'Дозвољено {{min}}–{{max}} km.',
          odometerMin: 'Најмање {{min}} km.',
          odometerMax: 'Највише {{max}} km.',
          odometerRequiredBlocking:
            'Исправите километражу у {{count}} ред(ова): {{rows}}.',
        },
        // Кодови које емитује бекенд FuelLogImportAnalyzer за валидационе/
        // дупликат поруке по реду (види FuelLogImportMessageCodes.cs).
        messageCodes: {
          MissingDate: 'Недостаје или је неисправан датум.',
          MissingProductName: 'Недостаје назив производа.',
          InvalidQuantity: 'Количина недостаје или није позитивна.',
          InvalidTotalCost: 'Укупан трошак недостаје или није позитиван.',
          MissingUnit: 'Недостаје јединица мере.',
          MissingOdometer: 'Недостаје километража. Унесите је пре увоза.',
          VehicleNotFound: 'Возило није пронађено по регистрацији или интерном коду.',
          UnknownUnit: 'Непозната јединица мере „{{unit}}".',
          DuplicateMatch: 'Поклапа се са постојећим уносом (исто возило/датум/време/производ/рачун). Означите да препишете.',
          UnknownProduct: 'Производ {{sku}} „{{name}}" није у каталогу. Додајте га у каталог па освежите преглед.',
          UnitMismatch: 'Јединица у фајлу ({{actual}}) се разликује од јединице у каталогу ({{expected}}).',
        },
        unknownProducts: {
          alert: 'Редова са производом који није у каталогу: {{count}}. Додајте производе у каталог, па освежите преглед; до тада се ти редови не увозе.',
          addToCatalog: 'Додај у каталог',
          refresh: 'Освежи преглед',
        },
        duplicateFile: {
          warning: 'Овај фајл је већ увезен ({{fileName}}, {{importedAt}}, корисник: {{importedBy}}, увезено редова: {{count}}). Ако наставите, редови препознати као дупликати биће прескочени; означите их ручно ако желите да ажурирате постојеће записе.',
        },
        result: {
          title: 'Увоз завршен',
          imported: 'Увезено нових: {{count}}',
          updated: 'Ажурирано постојећих: {{count}}',
          skipped: 'Прескочено: {{count}}',
          invalid: 'Невалидно: {{count}}',
        },
      },
      catalog: {
        menuItem: 'Каталог производа',
        title: 'Каталог производа горива',
        subtitle: 'Производи са НИС картице по шифри. Увоз разврстава редове искључиво преко овог каталога; непозната шифра зауставља ред док се производ не дода.',
        searchPlaceholder: 'Претражи по шифри или називу',
        add: 'Додај производ',
        addTitle: 'Нови производ',
        editTitle: 'Измена производа',
        empty: 'Нема производа.',
        note: 'Напомена',
        active: 'Активан',
        inactive: 'Неактиван',
        skuHint: 'Шифра из НИС извештаја (колона SIFRAROBA).',
        otherHint: 'Улази у трошак, не улази у потрошњу горива.',
        inactiveHint: 'Неактиван производ се при увозу третира као непознат и не нуди се при измени уноса.',
      },
      validation: {
        vehicleRequired: 'Возило је обавезно',
        odometerInvalid: 'Унесите валидну вредност',
        odometerMinimumValue: 'Километража не може бити 0',
        odometerMinimum: 'Километража мора бити већа или једнака {{min}} km',
        odometerMaximum: 'Километража не може бити већа од {{max}} km',
      },
      warnings: {
        odometerBelowCurrent: 'Упозорење: Унета километража ({{entered}} km) је мања од тренутне километраже возила ({{current}} km). Ово може бити у реду ако уносите историјске податке.',
        productNotInCatalog: 'Производ {{product}} није у каталогу. Изаберите производ из каталога или га прво додајте у каталог.',
      },
      helpers: {
        product: 'Тип производа, тип горива и јединица се преузимају из каталога.',
        odometerRange: 'Минимално: {{min}} km',
        odometerRangeWithMax: 'Минимално: {{min}} km, Максимално: {{max}} km',
        pricePerLiter: 'Опционо - ако унесете, укупан трошак ће бити аутоматски израчунат',
        totalCost: 'Обавезно - унесите укупан трошак или цену по литри',
      },
    },
    fleetUsers: {
      title: 'Корисници возног парка',
      list: {
        title: 'Корисници',
        subtitle: 'Преглед корисника возног парка',
      },
      detail: {
        title: 'Детаљи корисника',
      },
      create: {
        title: 'Нови корисник',
        subtitle: 'Додај новог корисника возног парка',
      },
      edit: {
        title: 'Измени корисника',
        subtitle: 'Измени податке корисника',
      },
      fields: {
        firstName: 'Име',
        lastName: 'Презиме',
        email: 'Email',
        operationalUnit: 'Организациона јединица',
        driverLicenseNumber: 'Број возачке дозволе',
        driverLicenseCategories: 'Категорије',
        driverLicenseCategoriesHelper: 'Унесите категорије одвојене зарезом (нпр. B, C, D)',
        driverLicenseExpiryDate: 'Датум истека',
        phoneNumber: 'Телефон',
      },
      tabs: {
        basicInfo: 'Основни подаци',
        driverInfo: 'Возачка дозвола',
        requests: 'Захтеви',
        travelOrders: 'Вожње',
        unitAuthorizations: 'Овлашћења',
      },
      sections: {
        basicInfo: 'Основни подаци',
        driverLicense: 'Возачка дозвола',
        contactInfo: 'Контакт информације',
      },
      unitAuthorizations: {
        title: 'Овлашћења по организационим јединицама',
        subtitle:
          'Јединице над којима корисник има додатна овлашћења за рад, укључујући матичну јединицу.',
        showHistory: 'Прикажи историју',
        empty: 'Нема додељених овлашћења',
        fields: {
          operationalUnit: 'Организациона јединица',
          validFrom: 'Важи од',
          validTo: 'Важи до',
          reason: 'Разлог',
          grantedBy: 'Доделио',
          status: 'Статус',
          revocationReason: 'Разлог опозива',
        },
        status: {
          active: 'Активно',
          revoked: 'Опозвано',
          expired: 'Истекло',
        },
        grant: {
          action: 'Додели овлашћење',
          title: 'Додела овлашћења',
          description:
            'Корисник добија право рада над изабраном организационом јединицом. Ако датуми нису унети, овлашћење важи трајно.',
          validFromHelper: 'Празно = одмах',
          validToHelper: 'Празно = без рока',
          submit: 'Додели',
        },
        revoke: {
          action: 'Опозови',
          title: 'Опозив овлашћења',
          description: 'Овлашћење над јединицом {{unit}} биће опозвано, али остаје у историји.',
          submit: 'Опозови',
        },
      },
      noRequests: 'Нема захтева',
      noTravelOrders: 'Нема вожњи',
      createSuccess: 'Корисник успешно креиран',
      updateSuccess: 'Корисник успешно ажуриран',
      licenseExpiringSoon: 'Возачка дозвола истиче ускоро',
      licenseExpired: 'Возачка дозвола је истекла',
    },
    workOrders: {
      title: 'Радни налози',
      subtitle: 'Преглед и управљање радним налозима',
      create: 'Нови радни налог',
      edit: 'Измена радног налога',
      types: {
        Service: 'Сервис',
        TireService: 'Вулканизер',
      },
      statuses: {
        Draft: 'Нацрт',
        Issued: 'Издат',
        Completed: 'Завршен',
        Cancelled: 'Отказан',
      },
      filters: {
        type: 'Тип',
        status: 'Статус',
        search: 'Претрага',
        searchPlaceholder: 'Број, таблица, добављач...',
        allTypes: 'Сви типови',
        allStatuses: 'Сви статуси',
      },
      table: {
        number: 'Број',
        type: 'Тип',
        status: 'Статус',
        vehicle: 'Возило',
        provider: 'Добављач',
        createdOn: 'Датум креирања',
        issuedOn: 'Датум издавања',
        items: 'Ставке',
      },
      empty: {
        default: 'Нема радних налога',
        filtered: 'Нема резултата са тренутним филтерима',
      },
      errors: {
        loadFailed: 'Грешка при учитавању радних налога. Покушајте поново.',
        notFound: 'Радни налог није пронађен или је дошло до грешке при учитавању.',
      },
      actions: {
        complete: 'Заврши налог',
        delete: 'Обриши налог',
        downloadPdf: 'Преузми PDF',
        generatingPdf: 'Генерисање PDF...',
        createService: 'Креирај сервис',
        createTireService: 'Креирај вулканизерски сервис',
        completeDisabledHint: 'Радни налог се може завршити само ако има сервис или је означен као рекламација.',
      },
      service: {
        createTitle: 'Нови сервис за радни налог',
        createTitleWithNumber: 'Нови сервис за радни налог {{number}}',
        contextSection: 'Подаци из радног налога',
        cannotAttachComplaint: 'Радни налог је означен као рекламација и не може имати сервис.',
        alreadyHasService: 'Радни налог већ има повезан сервис.',
        notIssued: 'Сервис се може креирати само за издате радне налоге.',
      },
      tireService: {
        createTitle: 'Нови вулканизерски сервис за радни налог',
        createTitleWithNumber: 'Нови вулканизерски сервис за радни налог {{number}}',
      },
      dialogs: {
        deleteTitle: 'Обриши радни налог',
        deleteMessage: 'Да ли сте сигурни да желите да трајно обришете овај радни налог? Ова акција се не може поништити.',
        completeTitle: 'Заврши радни налог',
        completeMessage: 'Да ли сте сигурни да желите да означите овај радни налог као завршен?',
        completing: 'Завршавање...',
        confirmComplete: 'Заврши',
      },
      detail: {
        titleWithNumber: 'Радни налог {{number}}',
        titleDraft: 'Нацрт радног налога',
        vehicleSection: 'Возило',
        providerSection: 'Добављач / Уговор',
        vehicleStateSection: 'Стање возила и опрема',
        equipmentSubtitle: 'Опрема на возилу',
        workItemsSection: 'Ставке рада',
        noItems: 'Нема ставки',
        vulcanizerSection: 'Услуге вулканизера',
        noServices: 'Нема услуга',
        notesSection: 'Напомене',
        metadataSection: 'Подаци о налогу',
        attachedServiceTitle: 'Повезан сервис',
        attachedServiceSubtitle: 'Број сервиса: {{number}}',
        attachedServiceSubtitleNoNumber: 'Сервис је повезан са овим радним налогом.',
        viewService: 'Отвори сервис',
        itemCount: '{{count}} ставки',
        table: {
          ordinal: '#',
          description: 'Опис',
          notes: 'Напомена',
          rowNum: 'Р.бр.',
          serviceName: 'Назив услуге',
          quantity: 'Количина',
        },
        fields: {
          internalCode: 'Интерна ознака',
          brandModel: 'Марка / Модел',
          plateNumber: 'Регистарска ознака',
          odometer: 'Стање километраже',
          orderType: 'Тип налога',
          providerName: 'Назив добављача',
          contractNumber: 'Број уговора',
          contractValidity: 'Важност уговора',
          fuelLevel: 'Ниво горива',
          damageNotes: 'Оштећења на возилу',
          createdBy: 'Креирао',
          createdOn: 'Датум креирања',
          issuedOn: 'Датум издавања',
          completedOn: 'Датум завршетка',
          cancelledOn: 'Датум отказивања',
          cancellationReason: 'Разлог отказивања',
        },
      },
      form: {
        basicInfo: 'Основни подаци',
        providerSection: 'Добављач и уговор',
        vehicleStateSection: 'Стање возила',
        equipmentSection: 'Опрема на возилу',
        notesSection: 'Напомене',
        vulcanizerSection: 'Услуге вулканизера',
        workItemsSection: 'Ставке рада',
        noServices: 'Нема услуга',
        noActiveContracts: 'Нема активних уговора',
        noTireContracts: 'Нема активних уговора за вулканизерске услуге за овог добављача',
        selectProviderFirst: 'Прво изаберите добављача',
        addEquipment: 'Додај опрему',
        removeEquipment: 'Уклони',
        addItem: 'Додај ставку',
        removeItem: 'Уклони ставку',
        addService: 'Додај услугу',
        removeService: 'Уклони услугу',
        notesPlaceholder: 'Унесите напомене...',
        equipmentNamePlaceholder: 'Назив опреме',
        fields: {
          type: 'Тип налога',
          vehicle: 'Возило',
          provider: 'Добављач',
          contract: 'Уговор',
          odometer: 'Стање километраже (км)',
          fuelLevel: 'Ниво горива (%)',
          damageNotes: 'Оштећења на возилу',
          damageNotesPlaceholder: 'Опишите оштећења на возилу...',
          itemDescription: 'Опис ставке {{number}}',
          itemNote: 'Напомена',
        },
      },
      validation: {
        vehicleRequired: 'Возило је обавезно',
        providerRequired: 'Добављач је обавезан',
        contractRequired: 'Уговор је обавезан',
        odometerRequired: 'Стање километраже је обавезно',
        odometerPositive: 'Стање километраже мора бити веће од 0',
        fuelLevelRange: 'Ниво горива мора бити између 0 и 100',
        itemRequired: 'Бар једна ставка са описом је обавезна',
        serviceRequired: 'Бар једна услуга са називом је обавезна',
      },
    },
    operationalUnits: {
      title: 'Организационе јединице',
      create: 'Нова јединица',
      createTitle: 'Нова организациона јединица',
      edit: 'Измени организациону јединицу',
      searchPlaceholder: 'Претражи јединице...',
      table: {
        name: 'Назив',
        sapCode: 'SAP шифра',
        cityPrefix: 'Префикс града',
        status: 'Статус',
      },
      empty: {
        default: 'Нема организационих јединица.',
        filtered: 'Нема резултата претраге.',
      },
      status: {
        active: 'Активно',
        archived: 'Архивирано',
      },
      fields: {
        name: 'Назив',
        sapCode: 'SAP шифра',
        cityPrefix: 'Префикс града',
        cityPrefixHint: 'Нпр. НС, БГ, ПА, ЗР, КИ',
      },
    },
  },
  users: {
    nav: {
      users: 'Корисници',
      employeeAccounts: 'Налози запослених',
      roles: 'Улоге',
      permissions: 'Пермисије',
    },
    list: {
      title: 'Корисници',
      subtitle: 'Управљање корисницима система',
      addUser: 'Додај корисника',
      search: 'Претрага',
      searchPlaceholder: 'Име, презиме или email',
      allRoles: 'Све улоге',
      active: 'Активни',
      archived: 'Архивирани',
      archiveConfirm: 'Да ли сте сигурни да желите да архивирате корисника {{name}}?',
      restoreConfirm: 'Да ли сте сигурни да желите да вратите корисника {{name}} из архиве?',
      table: {
        firstName: 'Име',
        lastName: 'Презиме',
        email: 'Email',
        role: 'Улога',
        roles: 'Улоге',
        status: 'Статус',
        actions: 'Акције',
      },
      statuses: {
        active: 'Активно',
        archived: 'Архивирано',
      },
      actions: {
        edit: 'Измени',
        archive: 'Архивирај',
        restore: 'Врати',
      },
    },
    form: {
      createTitle: 'Нови корисник',
      editTitle: 'Измени корисника',
      basicInfo: 'Основни подаци',
      email: 'Email',
      firstName: 'Име',
      lastName: 'Презиме',
      roles: 'Улоге',
      emailPlaceholder: 'korisnik@example.com',
      firstNamePlaceholder: 'Име',
      lastNamePlaceholder: 'Презиме',
      rolesHelper: 'Изаберите једну или више улога за корисника',
      rolesReadonlyHelper: 'Улоге може мењати само овлашћени корисник',
      newUserInfo: 'Корисник ће добити email са линком за постављање лозинке.',
      create: 'Креирај',
      save: 'Сачувај',
      cancel: 'Откажи',
      validation: {
        required: 'Ово поље је обавезно',
        invalidEmail: 'Унесите валидну email адресу',
        roleRequired: 'Изаберите бар једну улогу',
        requiredFields: 'Попуните сва обавезна поља',
      },
    },
    employeeAccounts: {
      title: 'Налози запослених',
      subtitle: 'Преглед запослених и њихових корисничких налога',
      search: 'Претрага',
      searchPlaceholder: 'Име, email, радна јединица или радно место',
      table: {
        employee: 'Запослени',
        businessEmail: 'Пословни email',
        workUnitAndPosition: 'Радна јединица / место',
        accountStatus: 'Статус налога',
        roles: 'Улоге',
        actions: 'Акције',
      },
      statuses: {
        hasAccount: 'Има налог',
        accountArchived: 'Налог архивиран',
        missingBusinessEmail: 'Нема пословни email',
        emailAlreadyUsed: 'Email већ користи налог',
        noAccount: 'Нема налог',
      },
      blockingReasons: {
        missingBusinessEmail: 'Нема пословни email',
        emailAlreadyUsed: 'Пословни email већ користи други кориснички налог',
      },
      actions: {
        createAccount: 'Креирај налог',
        openUser: 'Отвори корисника',
      },
      createDialog: {
        title: 'Креирај налог запосленом',
        roles: 'Улоге',
        rolesHelper: 'Изаберите једну или више улога за корисника',
        cancel: 'Откажи',
        create: 'Креирај налог',
        creating: 'Креирање...',
      },
    },
    roles: {
      title: 'Улоге',
      subtitle: 'Креирање улога и управљање пермисијама које улога носи',
      add: 'Нова улога',
      listTitle: 'Улоге у систему',
      permissionsTitle: 'Пермисије улоге',
      role: 'Улога',
      type: 'Тип',
      system: 'Системска',
      custom: 'Корисничка',
      permissionsCount: 'Пермисије',
      usersCount: 'Корисници',
      selectRole: 'Изаберите улогу за уређивање пермисија',
      editPermissions: 'Пермисије',
      savePermissions: 'Сачувај пермисије',
      permissionSelectionHelp: 'Пермисије су груписане по модулима. Отворите модул и означите дозволе које ова улога треба да има.',
      permissionsSaved: 'Пермисије улоге су сачуване',
      created: 'Улога је креирана',
      systemHelp: 'Ово је системска улога. Измене утичу на све кориснике који је имају.',
      createDialog: {
        title: 'Нова улога',
        name: 'Назив улоге',
        nameHelp: 'Унесите јасан назив роле, нпр. Диспечер или Оператер логистике. Максимално 50 карактера.',
      },
    },
    permissions: {
      title: 'Пермисије',
      subtitle: 'Преглед системских пермисија. Пермисије се не креирају нити бришу кроз UI.',
      catalog: 'Каталог пермисија',
      search: 'Претрага',
      module: 'Модул',
      resource: 'Ресурс',
      action: 'Акција',
      code: 'Код',
      roles: 'Улоге',
      modules: {
        Fleet: 'Возни парк',
        Users: 'Корисници',
        HumanResources: 'Кадровска',
        Hr: 'Кадровски каталози',
        Documents: 'Документи',
      },
      actions: {
        Read: 'Преглед',
        Create: 'Креирање',
        Update: 'Измена',
        Delete: 'Брисање',
        Archive: 'Архивирање',
        Restore: 'Враћање',
        Manage: 'Управљање',
        Assign: 'Додела',
        Approve: 'Одобравање',
        Reject: 'Одбијање',
        Close: 'Затварање',
        Open: 'Отварање',
        Run: 'Покретање',
        Import: 'Увоз',
      },
    },
    access: {
      title: 'Приступ корисника',
      subtitle: 'Улоге и директне пермисије корисника',
      save: 'Сачувај приступ',
      saved: 'Приступ корисника је сачуван',
      roles: 'Улоге',
      directPermissions: 'Директне пермисије',
      directPermissionsHelp: 'Директне пермисије користите само за изузетке. Пермисије из улога су приказане посебно.',
      fromRole: 'из улоге',
      direct: 'директно',
    },
  },
  assignments: {
    warnings: {
      vehicleAlreadyAssigned: 'Упозорење: Возило је тренутно додељено кориснику {{userName}}. Нова додела ће аутоматски завршити тренутну доделу.',
      vehicleNotFree: 'Возило не може бити додељено јер тренутни статус није Слободно или У употреби. Тренутни статус: {{status}}',
      activeTravelOrders: 'Возило је тренутно на вожњи. Додела возача се може променити тек када се вожња заврши.',
    },
    dialog: {
      title: 'Додели возило {{plate}}',
      user: 'Корисник *',
      advancedOptions: 'Напредне опције',
      contractNumber: 'Број уговора (опционо)',
      notes: 'Напомене (опционо)',
      cancel: 'Одустани',
      assign: 'Додели',
      transferPeriodHolder: 'Пренеси и носиоца отвореног путног налога',
    },
    types: {
      Permanent: 'Стална',
      LongTerm: 'Дугорочна',
      Temporary: 'Привремена',
    },
  },
  vehicleBlocks: {
    create: { title: 'Нова недоступност' },
    update: { title: 'Измени недоступност' },
    close: { title: 'Затвори недоступност' },
    delete: { title: 'Обриши недоступност' },
    fields: {
      blockType: 'Тип недоступности',
      startDate: 'Датум почетка',
      startTime: 'Време почетка',
      endDate: 'Датум завршетка',
      endTime: 'Време завршетка',
      reason: 'Разлог',
      closedAt: 'Датум затварања',
    },
    helpers: {
      optional: 'Опционо',
      endDateEmpty: 'Оставите празно за трајну недоступност',
    },
    validation: {
      startDateRequired: 'Датум почетка је обавезан',
      reasonRequired: 'Разлог је обавезан',
      endDateAfterStart: 'Датум завршетка мора бити након датума почетка',
      closeDateRequired: 'Датум затварања је обавезан',
      closeDateAfterStart: 'Датум затварања мора бити након датума почетка',
    },
    errors: {
      create: 'Грешка приликом креирања недоступности',
      update: 'Грешка приликом ажурирања недоступности',
      close: 'Грешка приликом затварања недоступности',
      delete: 'Грешка приликом брисања недоступности',
    },
    actions: {
      cancel: 'Откажи',
      create: 'Креирај',
      creating: 'Креирање...',
      save: 'Сачувај',
      saving: 'Чување...',
      close: 'Затвори недоступност',
      closing: 'Затварање...',
      delete: 'Обриши',
      deleting: 'Брисање...',
    },
    confirm: {
      close: 'Да ли сте сигурни да желите да затворите ову недоступност?',
      delete: 'Да ли сте сигурни да желите да обришете ову недоступност? Ова акција се не може поништити.',
    },
    summary: {
      type: 'Тип',
      reason: 'Разлог',
      start: 'Почетак',
      end: 'Крај',
    },
    types: {
      Service: 'На сервису',
      OutOfService: 'Ван употребе',
      Manual: 'Ручна блокада',
    },
    list: {
      empty: 'Нема недоступности за ово возило.',
      active: 'Активна',
      inProgress: 'У току...',
      createdBy: 'Креирао',
      tooltips: {
        edit: 'Измени',
        close: 'Затвори недоступност',
        delete: 'Обриши',
      },
    },
  },
  account: {
    title: 'Мој налог',
    subtitle: 'Управљање налогом и лозинком',
    profile: 'Профил',
    userInformation: 'Информације о кориснику',
    firstName: 'Име',
    lastName: 'Презиме',
    email: 'Емаил',
    changePassword: 'Промени лозинку',
    passwordSection: 'Промена лозинке',
    currentPassword: 'Тренутна лозинка',
    newPassword: 'Нова лозинка',
    confirmPassword: 'Потврди лозинку',
    passwordChanged: 'Лозинка је успешно промењена',
    passwordChangeFailed: 'Грешка при промени лозинке',
    invalidCurrentPassword: 'Тренутна лозинка није исправна',
    passwordsDoNotMatch: 'Лозинке се не поклапају',
    passwordTooShort: 'Лозинка мора имати најмање 8 карактера',
    changePasswordButton: 'Промени лозинку',
    changingPassword: 'Промена лозинке...',
  },
  apiErrors: {
    // Identity provider (Keycloak) errors on user registration
    'Identity.EmailIsNotUnique': 'Корисник са овом е-мејл адресом већ постоји у систему за пријаву.',
    'Identity.RegistrationRejected':
      'Систем за пријаву је одбио регистрацију: подаци корисника или привремена лозинка не задовољавају политику лозинки.',
    'Identity.RegistrationFailed': 'Корисник није могао да буде регистрован у систему за пријаву. Покушајте поново касније.',
    // Travel Order Period errors
    'TravelOrderPeriod.NotFoundForMonth':
      'Путни налог за возило {{vehiclePlate}} у периоду {{period}} није креиран. Молимо креирајте путни налог пре одобравања захтева.',
    'TravelOrderPeriod.NotFound': 'Путни налог није пронађен.',
    'TravelOrderPeriod.InvalidVehicleId': 'ID возила је обавезан.',
    'TravelOrderPeriod.InvalidResponsibleEmployeeId': 'ID одговорног запосленог је обавезан.',
    'TravelOrderPeriod.InvalidMonth': 'Месец мора бити између 1 и 12.',
    'TravelOrderPeriod.TravelOrderNumberRequired': 'Број путног налога је обавезан.',
    'TravelOrderPeriod.PeriodAlreadyExists': 'Период путног налога већ постоји за ово возило и месец.',
    'TravelOrderPeriod.PeriodNotOpen': 'Период путног налога није отворен за додавање нових вожњи.',
    'TravelOrderPeriod.OverlappingPeriod': 'Период се преклапа са постојећим периодом за ово возило.',
    'TravelOrderPeriod.VehicleAlreadyHasOpenPeriod': 'Није могуће креирати нови период јер возило већ има отворен период. Затворите постојећи период прво.',
    'TravelOrderPeriod.PeriodVehicleMismatch': 'Одабрани период не припада овом возилу.',
    'TravelOrderPeriod.HasActiveTrips': 'Није могуће затворити период док постоје активне вожње.',
    'TravelOrderPeriod.HasNonClosedTrips': 'Није могуће затворити период док постоје незатворене вожње. Све вожње морају бити затворене или отказане.',
    'TravelOrderPeriod.HasOpenOrCompletedTrips': 'Све вожње морају бити затворене или отказане пре затварања периода.',
    'TravelOrderPeriod.InProgressTripWithoutNextSegment': 'Вожња у току нема наставак у следећем периоду. Завршите је или откажите.',
    'TravelOrderPeriod.CannotCloseBeforeMonthEnds': 'Период се може затворити само након последњег дана месеца.',
    'TravelOrderPeriod.CannotCloseInCurrentStatus': 'Период може бити затворен само када је отворен.',
    'TravelOrderPeriod.CannotCancelInCurrentStatus': 'Период може бити отказан само када је отворен.',
    'TravelOrderPeriod.CancellationReasonRequired': 'Разлог отказивања је обавезан.',
    'TravelOrderPeriod.CannotModifyClosedPeriod': 'Није могуће изменити затворени или отказани период.',
    'TravelOrderPeriod.RequestCrossesMonthBoundary': 'Датуми захтева морају бити унутар једног календарског месеца.',
    'TravelOrderPeriod.RequestOutsidePeriod': 'Датуми захтева су изван граница периода.',
    'TravelOrderPeriod.EndDateMustBeAfterStartDate': 'Датум завршетка мора бити након датума почетка.',
    'TravelOrderPeriod.CannotSetEndDateOnNonOpenEndedPeriod': 'Није могуће поставити датум завршетка на период који није отвореног типа.',
    'TravelOrderPeriod.StartDateRequired': 'Датум почетка је обавезан за отворене периоде.',
    'TravelOrderPeriod.InvalidOdometer': 'Стање километраже мора бити позитивна вредност.',
    'TravelOrderPeriod.EndOdometerLessThanStart': 'Завршна километража не може бити мања од почетне.',
    'TravelOrderPeriod.StartOdometerGreaterThanEnd': 'Почетна километража не може бити већа од завршне.',
    'TravelOrderPeriod.CannotModifyDatesOnMonthlyPeriod': 'Није могуће изменити датуме на месечном периоду.',
    'TravelOrderPeriod.CannotReopenInCurrentStatus': 'Само затворени периоди могу бити поново отворени.',
    'TravelOrderPeriod.CannotReopenOverlappingPeriod': 'Није могуће поново отворити период јер постоји други активни период за исти временски распон.',
    'TravelOrderPeriod.CannotModifyCancelledPeriod': 'Није могуће изменити отказани период.',
    'TravelOrderPeriod.NotAuthorizedForUnit': 'Немате овлашћење над јединицом овог возила.',
    'TravelOrderPeriod.NotAuthorizedToChangeResponsibleEmployee': 'Носиоца путног налога мења само менаџер путних налога за јединицу возила.',
    'TravelOrderPeriod.InvalidOperationalUnitId': 'Јединица путног налога је обавезна.',
    'TravelOrderPeriod.SameResponsibleEmployee': 'Изабрани запослени је већ носилац овог путног налога.',
    'TravelOrderPeriod.InvalidInitialStatus': 'Путни налог се може креирати само са статусом Отворен.',
    'TravelOrderPeriod.CannotCreatePastPeriod': 'Није могуће креирати путни налог за протекли месец. Дозвољени су само текући и будући месеци.',
    'TravelOrderPeriod.NotAuthorizedToEnterOdometer': 'Километражу на путни налог може унети само носилац налога или менаџер путних налога за јединицу возила.',
    'TravelOrderPeriod.OdometerChangeReasonRequired': 'Разлог је обавезан при измени већ унете завршне километраже.',
    'TravelOrderPeriod.OdometerOverrideReasonRequired': 'Разлог је обавезан када се налог затвара са крајњом километражом која се разликује од већ унете.',
    'TravelOrderPeriod.HasOdometerConflicts': 'Путни налог има вожње са одступањем километраже. Исправите их пре затварања.',
    'TravelOrderPeriod.StartOdometerDerivedFromPreviousPeriod': 'Почетно стање се не може мењати јер се преузима из крајњег стања претходног путног налога возила. Исправите крајње стање тог налога.',
    'TravelOrderPeriod.StartOdometerAboveFirstReading': 'Почетно стање не може бити веће од првог евидентираног очитавања километраже возила.',
    'TravelOrderPeriod.NotAuthorizedToEditStartOdometer': 'Почетно стање може да мења само носилац првог путног налога возила или менаџер путних налога за јединицу возила.',

    // Vehicle Request errors
    'VehicleRequest.NotFound': 'Захтев за возило није пронађен.',
    'VehicleRequest.InvalidVehicleId': 'ID возила је обавезан.',
    'VehicleRequest.InvalidRequesterId': 'ID подносиоца захтева је обавезан.',
    'VehicleRequest.PurposeRequired': 'Сврха је обавезна за захтев за возило.',
    'VehicleRequest.InvalidDateRange': 'Датум завршетка мора бити након датума почетка.',
    'VehicleRequest.StartDateInPast': 'Датум почетка не може бити у прошлости.',
    'VehicleRequest.VehicleNotAvailable': 'Возило није доступно за тражени период.',
    'VehicleRequest.AlreadyApproved': 'Захтев је већ одобрен.',
    'VehicleRequest.AlreadyRejected': 'Захтев је већ одбијен.',
    'VehicleRequest.AlreadyCancelled': 'Захтев је већ отказан.',
    'VehicleRequest.CannotApproveNonPending': 'Само захтеви на чекању могу бити одобрени.',
    'VehicleRequest.CannotRejectNonPending': 'Само захтеви на чекању могу бити одбијени.',
    'VehicleRequest.CannotCancelInCurrentStatus': 'Захтев не може бити отказан у тренутном статусу.',
    'VehicleRequest.CannotCancelApprovedRequest': 'Одобрени захтеви не могу бити отказани. Молимо откажите вожњу уместо тога.',
    'VehicleRequest.CannotCancelActiveTripRequest':
      'Није могуће отказати захтев јер је вожња већ у току или завршена.',
    'VehicleRequest.OverlappingRequest': 'Постоји преклапајући одобрен захтев за ово возило.',
    'VehicleRequest.InvalidApproverId': 'Неважећи ID одобравача.',
    'VehicleRequest.RejectionReasonRequired': 'Разлог одбијања је обавезан.',
    'VehicleRequest.CannotLinkTravelOrderToNonApproved': 'Вожња може бити повезана само са одобреним захтевима.',
    'VehicleRequest.CannotCompleteNonApproved': 'Само одобрени захтеви могу бити означени као завршени.',
    'VehicleRequest.VehicleAssignedToAnotherDriver': 'Ово возило је додељено другом возачу. Само додељени возач или менаџери возног парка могу га захтевати.',
    'VehicleRequest.VehicleReservationFailed': 'Грешка при резервацији возила током процеса одобравања.',
    'VehicleRequest.TravelOrderCreationFailed': 'Грешка при креирању вожње.',
    'VehicleRequest.VehicleNotAssigned': 'Возило мора бити додељено пре него што захтев може бити одобрен.',
    'VehicleRequest.CannotAssignVehicleToNonPending': 'Возило може бити додељено само захтевима на чекању.',
    'VehicleRequest.VehiclePlateNumberRequired': 'Регистарска ознака возила је обавезна при додели возила.',
    'VehicleRequest.VehicleDescriptionRequired': 'Опис возила је обавезан при додели возила.',
    'VehicleRequest.Forbidden': 'Немате дозволу за приступ овом захтеву за возило.',
    'VehicleRequest.NotAuthorizedForVehicle': 'Немате овлашћење за деловање на захтевима за ово возило.',
    'VehicleRequest.NotAuthorizedToCreateForOthers': 'Немате дозволу за подношење захтева у туђе име.',

    // Travel Order errors
    'TravelOrder.NotFound': 'Вожња није пронађена.',
    'TravelOrder.NotFoundByOrderNumber': 'Вожња са наведеним бројем није пронађена.',
    'TravelOrder.RequestNotApproved': 'Вожња може бити креирана само из одобрених захтева.',
    'TravelOrder.TravelOrderNumberRequired': 'Број вожње је обавезан.',
    'TravelOrder.VehicleAlreadyInUse': 'Возило је већ у употреби на другој вожњи.',
    'TravelOrder.CannotStartInCurrentStatus': 'Вожња не може бити покренута у тренутном статусу.',
    'TravelOrder.CannotEndInCurrentStatus': 'Вожња не може бити завршена у тренутном статусу.',
    'TravelOrder.EndOdometerLessThanStart': 'Завршна километража не може бити мања од почетне.',
    'TravelOrder.CannotCloseInCurrentStatus': 'Вожња може бити затворена само када је завршена.',
    'TravelOrder.CannotCancelInCurrentStatus': 'Вожња може бити отказана само када је отворена.',
    'TravelOrder.CannotAddFuelLogInCurrentStatus': 'Евиденција горива може бити додана само на вожње у току, завршене или затворене вожње.',
    'TravelOrder.CancellationReasonRequired': 'Разлог отказивања је обавезан.',
    'TravelOrder.InvalidVehicleId': 'ID возила је обавезан.',
    'TravelOrder.InvalidDriverId': 'ID возача је обавезан.',
    'TravelOrder.InvalidOdometer': 'Стање километраже мора бити позитивна вредност.',
    'TravelOrder.VehicleNotAssigned': 'Није могуће креирати вожњу без додељеног возила.',
    'TravelOrder.OverlappingTravelOrder': 'Није могуће креирати вожњу јер већ постоји активна вожња за ово возило у траженом периоду.',
    'TravelOrder.CannotUpdateInCurrentStatus': 'Детаљи вожње могу бити ажурирани само када је отворена (није још покренута).',
    'TravelOrder.PeriodIdRequired': 'ID периода путног налога је обавезан.',
    'TravelOrder.InvalidTripNumber': 'Број вожње мора бити позитиван цео број.',
    'TravelOrder.NotAuthorized': 'Немате дозволу за ову акцију на вожњи.',
    'TravelOrder.HolderCanOnlyAddOwnTrips': 'Носилац путног налога може да дода само вожњу у којој је сам возач. Вожњу за другог возача поднесите као захтев за возило.',
    'TravelOrder.Forbidden': 'Немате дозволу за приступ овој вожњи.',
    'TravelOrder.StartDateInPast': 'Датум и време почетка не могу бити у прошлости.',
    'TravelOrder.EndDateBeforeStartDate': 'Датум завршетка мора бити након датума почетка.',
    'TravelOrder.CurrentUserIdRequired': 'ID тренутног корисника је обавезан.',
    'TravelOrder.DestinationTooLong': 'Релација може имати највише 200 карактера.',
    'TravelOrder.PurposeTooLong': 'Сврха може имати највише 500 карактера.',
    'TravelOrder.OdometerCorrectionValueRequired': 'Унесите бар једну вредност километраже (почетну или завршну).',
    'TravelOrder.CannotCorrectOdometerInCurrentStatus': 'Километража вожње може се исправити тек када је вожња започета и само ако није отказана.',
    'TravelOrder.EndOdometerCorrectionRequiresEndedTrip': 'Завршна километража може се исправити тек када је вожња завршена.',
    'TravelOrder.NotAuthorizedToCorrectOdometer': 'Километражу вожње може исправити само возач док вожња није затворена или менаџер вожњи за јединицу возила.',
    'TravelOrder.OdometerCorrectionRequiresOpenPeriod': 'Путни налог коме вожња припада мора бити отворен. Прво поново отворите путни налог.',

    // Odometer chain errors
    'Odometer.OutOfChain': 'Километража се не уклапа између суседних очитавања возила (претходног и следећег).',
    'Odometer.BelowLastReading': 'Километража возила не може бити мања од последњег евидентираног очитавања. Уместо тога исправите погрешно очитавање.',
    'Odometer.BelowInitialOdometer': 'Километража је мања од почетног стања возила, а возило још нема очитавања. Прво исправите стање километраже возила.',

    // Odometer correction errors
    'OdometerCorrection.NotFound': 'Корекција километраже није пронађена.',
    'OdometerCorrection.InvalidVehicleId': 'ID возила је обавезан за корекцију километраже.',
    'OdometerCorrection.InvalidTargetId': 'Није наведено шта се исправља (вожња, путни налог или возило).',
    'OdometerCorrection.InvalidFieldForTarget': 'Изабрано поље километраже не одговара врсти записа који се исправља.',
    'OdometerCorrection.InvalidValue': 'Километража мора бити ненегативна вредност.',
    'OdometerCorrection.ReasonRequired': 'Разлог корекције километраже је обавезан.',
    'OdometerCorrection.CorrectedByRequired': 'Није познато ко врши корекцију километраже.',
    'OdometerCorrection.OnlyVehicleCorrectionsCanBeVoided': 'Могу се сторнирати само ручне корекције возила. Километража вожње или путног налога исправља се новом исправком.',
    'OdometerCorrection.AlreadyVoided': 'Корекција километраже је већ сторнирана.',
    'OdometerCorrection.VoidReasonRequired': 'Разлог сторнирања је обавезан.',
    'OdometerCorrection.InvalidTargetType': 'Неважећа врста записа за корекцију километраже.',

    // Work Order errors
    'WorkOrder.NotAuthorizedForType': 'Немате дозволу за овај тип радног налога.',

    // Operation Record errors
    'OperationRecord.NotAuthorizedForType': 'Немате дозволу за овај тип трошка.',

    // Vehicle errors
    'Vehicle.NotFound': 'Возило није пронађено.',
    'Vehicle.InvalidBrand': 'Марка возила је обавезна.',
    'Vehicle.InvalidModel': 'Модел возила је обавезан.',
    'Vehicle.InvalidPlateNumber': 'Регистарска ознака возила је обавезна.',
    'Vehicle.PlateNumberAlreadyExists': 'Возило са овом регистарском ознаком већ постоји.',
    'Vehicle.InvalidOdometerReading': 'Стање километраже мора бити позитивна вредност.',
    'Vehicle.InvalidPassengerSeats': 'Број путничких седишта мора бити позитивна вредност.',
    'Vehicle.InvalidRegistrationDates': 'Датум истека регистрације мора бити након датума регистрације.',
    'Vehicle.InvalidFleetUserId': 'ID корисника возног парка је обавезан за доделу возача.',
    'Vehicle.InvalidFleetUserName': 'Име корисника возног парка је обавезно за доделу возача.',
    'Vehicle.NoActiveAssignment': 'Није пронађена активна додела возача за ово возило.',
    'Vehicle.InvalidExpectedEndDate': 'Очекивани датум завршетка мора бити у будућности за дугорочне доделе.',
    'Vehicle.ExpectedEndDateRequiredForLongTerm': 'Очекивани датум завршетка је обавезан за дугорочне доделе.',
    'Vehicle.InvalidAssignmentType': 'Неважећи тип доделе. Мора бити Привремена, Дугорочна или Стална.',
    'Vehicle.AlreadyArchived': 'Возило је већ архивирано.',
    'Vehicle.CannotArchiveInUse': 'Возило не може бити архивирано док је у употреби.',
    'Vehicle.InvalidDescription': 'Опис је обавезан.',
    'Vehicle.InvalidCost': 'Трошак мора бити већи од нуле.',
    'Vehicle.NotFree': 'Возило није у валидном статусу за ову операцију.',
    'Vehicle.NotReserved': 'Возило не може бити означено као у употреби у тренутном статусу.',
    'Vehicle.Disposed': 'Возило је продато или расходовано и не може променити статус.',
    'Vehicle.NotAvailable': 'Возило није доступно за тражени период.',
    'Vehicle.AlreadyRegistered': 'Возило је већ регистровано. Користите обнову регистрације.',
    'Vehicle.NotRegistered': 'Возило није регистровано. Није могуће обновити регистрацију за нерегистровано возило.',
    'Vehicle.InvalidRegistrationNumber': 'Број саобраћајне није исправан.',
    'Vehicle.OverlappingRegistration': 'Регистрација већ постоји за ово возило у наведеном периоду.',
    'Vehicle.CannotChangeDriverWithActiveTravelOrders': 'Није могуће променити доделу возача док је вожња у току.',
    'Vehicle.BlockNotFound': 'Блокада возила није пронађена.',
    'Vehicle.InvalidBlockReason': 'Разлог блокаде је обавезан.',
    'Vehicle.InvalidBlockDates': 'Датум завршетка блокаде мора бити након датума почетка.',
    'Vehicle.OverlappingBlock': 'Блокада већ постоји за ово возило у наведеном периоду.',
    'Vehicle.BlockAlreadyClosed': 'Ова блокада је већ затворена.',
    'Vehicle.CannotArchiveWithActiveBlocks': 'Возило не може бити архивирано док има активне блокаде.',
    'Vehicle.HasOverlappingTravelOrder': 'Возило има одобрену(активну) вожњу у траженом периоду.',
    'Vehicle.HasOverlappingBlock': 'Возило је блокирано у траженом периоду.',
    'Vehicle.TransferToSameUnit': 'Возило већ припада изабраној јединици.',
    'Vehicle.TransferDateBeforeLastTransfer': 'Датум премештаја не може бити пре последњег евидентираног премештаја.',
    'Vehicle.OperationalUnitChangeRequiresTransfer': 'Јединица се не може мењати изменом возила. Користите премештај возила.',
    'Vehicle.CannotTransferWithTripInProgress': 'Возило се не може преместити док је вожња у току. Прво завршите вожњу.',
    'Vehicle.CannotTransferNotAuthorized': 'Немате овлашћење да премештате возила између ових јединица.',
    'Vehicle.NotAuthorizedForUnit': 'Немате овлашћење над јединицом овог возила.',
    'FuelLog.NotAuthorizedForUnit': 'Унос горива може мењати или брисати само менаџер за јединицу возила.',
    'FuelProduct.SkuAlreadyExists': 'Производ са том шифром већ постоји у каталогу.',
    'FuelProduct.InvalidSku': 'Шифра производа је обавезна.',
    'FuelProduct.InvalidName': 'Назив производа је обавезан.',
    'FuelProduct.FuelTypeRequired': 'Гориво мора имати тип горива.',
    'FuelProduct.FuelTypeNotAllowed': 'Тип горива се уписује само за гориво.',
    'FuelProduct.NotFound': 'Производ није пронађен.',
    'FuelLog.NotFound': 'Унос горива није пронађен.',
    'FuelLog.InvalidQuantity': 'Количина мора бити већа од нуле.',
    'FuelLog.InvalidTotalCost': 'Укупан трошак мора бити већи од нуле.',
    'FuelLog.InvalidOdometerReading': 'Километража не може бити негативна.',
    'FuelLog.InvalidProductName': 'Назив производа је обавезан.',
    'FuelLog.InvalidProductType': 'Тип производа није исправан.',
    'FuelLog.InvalidUnit': 'Јединица мере није исправна.',
    'FuelLog.InvalidFuelType': 'Тип горива није исправан.',
    'FuelLog.FuelMustHaveFuelType': 'Гориво мора имати тип горива.',
    'FuelLog.AdBlueCannotHaveFuelType': 'Тип горива се уписује само за гориво.',
    'FuelLog.DateOutsidePeriodRange': 'Датум сипања мора бити унутар периода путног налога.',
    'FuelLog.CannotAddToCancelledPeriod': 'Гориво се не може додати на отказан путни налог.',
    'FuelLog.CannotModifyFuturePeriod': 'Гориво се не може додати на путни налог који још није почео.',
    'FuelLogImport.InvalidFile': 'Фајл није исправан НИС Excel извештај. Проверите формат и лист „Izvestaj".',
    'FuelLogImport.OdometerRequired': 'Сваки ред мора имати километражу пре увоза.',
    'FuelProduct.InvalidProductType': 'Тип производа није исправан.',
    'FuelProduct.InvalidFuelType': 'Тип горива није исправан.',
    'FuelProduct.InvalidUnit': 'Јединица мере није исправна.',
    'Vehicle.InvalidOperationalUnitId': 'Јединица је обавезна.',
    'Vehicle.InvalidInternalCode': 'Интерни број возила је обавезан.',
    'Vehicle.InvalidReferenceConsumption': 'Референтна потрошња мора бити већа од нуле.',
    'Vehicle.InvalidConsumptionTolerance': 'Толеранција потрошње мора бити између 0 и 100 процената.',
    'Vehicle.NotInRequestPool': 'Возило није доступно за захтеве.',
    'Vehicle.RegistrationExpiredForPeriod': 'Регистрација возила не важи за тражени период. Обновите регистрацију пре подношења захтева.',

    // Operational Unit errors
    'OperationalUnit.InvalidId': 'Јединица је обавезна.',
    'OperationalUnit.InvalidName': 'Назив јединице је обавезан.',
    'OperationalUnit.InvalidSapCode': 'САП шифра је обавезна.',
    'OperationalUnit.InvalidCityPrefix': 'Префикс града је обавезан.',
    'OperationalUnit.MissingCityPrefix': 'Јединица нема подешен префикс града, па није могуће доделити интерни број возила.',
    'OperationalUnit.AlreadyArchived': 'Јединица је већ архивирана.',
    'OperationalUnit.NotArchived': 'Јединица није архивирана.',
    'OperationalUnit.DuplicateSapCode': 'Јединица са овом САП шифром већ постоји.',
    'OperationalUnit.NotFound': 'Јединица није пронађена.',

    // Fleet User errors
    'FleetUser.NotFound': 'Корисник возног парка није пронађен.',

    // HR Catalog errors
    'EducationQualificationCatalog.LevelAndTypeConflict': 'НОКС квалификација са унетом шифром нивоа и врстом већ постоји.',
    'EducationQualificationCatalog.NoksDisplayDoesNotMatchLevel': 'Приказ НОКС мора почети вредношћу из поља НОКС ниво.',

    // Employee document errors
    'EmployeeDocument.CannotUploadFinal': 'Коначни документ се може додати само док је документ у статусу нацрта.',
    'EmployeeDocument.CannotRegenerate': 'Нацрт се може регенерисати само док је документ још увек нацрт.',
    'EmployeeDocument.CannotReplaceFinal': 'Коначни документ се може заменити само пре него што буде архивиран.',
    'EmployeeDocument.CannotHardDelete': 'Документ се може обрисати само док није у архиви (никад послат или неуспео покушај). Откажите документе који се шаљу или су већ архивирани.',
    'EmployeeDocument.CannotUpdateMetadata': 'Подаци се не могу мењати за архивиране или отказане документе.',
    'EmployeeDocument.InvalidFinalFile': 'Фајл коначног документа није исправан.',

    // Document template errors
    'DocumentTemplate.CannotDeleteUsed': 'Шаблон је већ коришћен за генерисање докумената и не може се обрисати. Уместо брисања га деактивирајте.',

    // Generic fallback
    default: 'Дошло је до грешке. Покушајте поново.',
  },
  tireTracking: {
    nav: 'Евиденција гума',
    title: 'Гуме',
    addNew: 'Нова гума',
    searchPlaceholder: 'Претражи по марки, димензији, возилу...',
    statusFilterLabel: 'Статус',
    seasonFilterLabel: 'Сезона',
    allStatuses: 'Сви статуси',
    allSeasons: 'Све типове',
    totalCount: 'Укупно: {{count}} гума',
    errorLoading: 'Грешка при учитавању гума.',
    emptyMessage: 'Нема гума за приказ.',
    emptyMessageFiltered: 'Нема гума које одговарају филтерима.',
    status: {
      InStorage: 'На складишту',
      InUse: 'У употреби',
      Disposed: 'Отписана',
    },
    season: {
      Summer: 'Летња',
      Winter: 'Зимска',
      AllSeason: 'Све сезоне',
    },
    position: {
      FrontLeft: 'Предња лева',
      FrontRight: 'Предња десна',
      RearLeft: 'Задња лева',
      RearRight: 'Задња десна',
      RearLeftOuter: 'Задња лева спољна',
      RearLeftInner: 'Задња лева унутрашња',
      RearRightOuter: 'Задња десна спољна',
      RearRightInner: 'Задња десна унутрашња',
      Spare: 'Резервна',
    },
    columns: {
      inventoryNumber: 'Инв. број',
      brandModel: 'Марка / Модел',
      dimension: 'Димензија',
      type: 'Тип',
      status: 'Статус',
      vehicle: 'Возило',
      position: 'Позиција',
      dot: 'DOT',
      actions: 'Акције',
    },
    tooltips: {
      view: 'Прикажи детаље',
      edit: 'Измени податке гуме',
      mount: 'Монтирај на возило',
      unmount: 'Скини с возила',
      editMileage: 'Измени почетни km',
      dispose: 'Отпиши',
      reactivate: 'Врати у складиште',
      delete: 'Обриши',
    },
    fields: {
      brand: 'Марка',
      model: 'Модел',
      dimension: 'Димензија',
      dimensionHint: 'Димензија (нпр. 205/55 R16)',
      seasonType: 'Тип сезоне',
      dotCode: 'DOT код',
      purchaseDate: 'Датум куповине',
      notes: 'Напомена',
      position: 'Позиција',
      mountDate: 'Датум монтаже',
      unmountDate: 'Датум скидања',
      mileageAtInstall: 'Километража при монтажи',
      mileageAtInstallLabel: 'Километража при монтажи (km)',
      mileageAtRemoval: 'Километража при скидању',
      optional: 'Опционо',
      vehicle: 'Возило',
      tireFromStorage: 'Гума из складишта',
      noTiresInStorage: 'Нема гума у складишту',
    },
    validation: {
      brandRequired: 'Марка је обавезна',
      dimensionRequired: 'Димензија је обавезна',
      mountDateRequired: 'Датум монтаже је обавезан',
      unmountDateRequired: 'Датум скидања је обавезан',
      mileagePositive: 'Километража мора бити позитивна',
      tireRequired: 'Одабир гуме је обавезан',
      quantityMin: 'Количина мора бити најмање 1',
      quantityMax: 'Количина не може бити већа од {{max}}',
      dotCodesCountMismatch: 'Број DOT кодова ({{actual}}) мора одговарати количини ({{expected}})',
      dotCodeTooLong: 'DOT код не може имати више од 20 карактера',
    },
    create: {
      title: 'Нова гума',
      submit: 'Креирај',
      submitting: 'Креирање...',
      error: 'Грешка приликом креирања гуме',
      cancel: 'Откажи',
      quantity: 'Количина',
      quantityHelper: 'Унесите 1 за једну гуму, или више за групни унос (макс {{max}})',
      dotCodesMode: 'DOT кодови',
      dotCodesModeNone: 'Без DOT кодова',
      dotCodesModeNoneHelper: 'Све гуме биће креиране без DOT кода. Можете их додати касније појединачно.',
      dotCodesModeList: 'Налепи листу DOT кодова',
      dotCodesListLabel: 'DOT кодови (један по реду)',
      dotCodesListHelper: '{{entered}} / {{expected}} кодова',
      bulkSubmit: 'Креирај {{count}} гума',
    },
    edit: {
      title: 'Измена гуме',
      submit: 'Сачувај',
      submitting: 'Чување...',
      error: 'Грешка приликом измене гуме',
      cancel: 'Откажи',
    },
    detail: {
      title: 'Детаљи гуме',
      inventoryNumber: 'Инвентарски број',
      brand: 'Марка',
      model: 'Модел',
      dimension: 'Димензија',
      seasonType: 'Тип сезоне',
      dotCode: 'DOT код',
      purchaseDate: 'Датум набавке',
      status: 'Статус',
      vehicle: 'Возило',
      position: 'Позиција',
      notes: 'Напомена',
      assignmentHistory: 'Историја монтаже',
      neverMounted: 'Гума није била монтирана.',
      active: 'Активна',
      table: {
        vehicle: 'Возило',
        position: 'Позиција',
        installed: 'Монтирано',
        removed: 'Скинуто',
        mileageAtInstall: 'km при монтажи',
        mileageAtRemoval: 'km при скидању',
      },
    },
    unmount: {
      title: 'Скини гуму с возила',
      submit: 'Скини гуму',
      submitting: 'Скидање...',
      error: 'Грешка приликом скидања гуме',
      cancel: 'Откажи',
    },
    dispose: {
      title: 'Отпиши гуму',
      confirm: 'Да ли сте сигурни да желите да отпишете гуму {{tire}}? Гума ће бити означена као отписана. Историја монтаже остаје сачувана.',
      submit: 'Отпиши',
      submitting: 'Отписивање...',
      error: 'Грешка приликом отписа гуме',
      cancel: 'Откажи',
    },
    reactivate: {
      title: 'Врати гуму у складиште',
      confirm: 'Да ли сте сигурни да желите да вратите гуму {{tire}} у складиште? Статус гуме ће бити промењен из "Отписана" у "На складишту".',
      submit: 'Врати у складиште',
      submitting: 'Враћање...',
      error: 'Грешка приликом реактивације гуме',
      cancel: 'Откажи',
    },
    editMileage: {
      title: 'Измени почетну километражу',
      tireInfo: 'Гума: {{info}}',
      submit: 'Сачувај',
      submitting: 'Чување...',
      error: 'Грешка приликом измене километраже',
      cancel: 'Откажи',
    },
    mount: {
      title: 'Монтирај гуму',
      submit: 'Монтирај',
      submitting: 'Монтажа...',
      error: 'Грешка приликом монтаже гуме',
      cancel: 'Откажи',
    },
    mountToVehicle: {
      title: 'Монтирај гуму на возило',
      vehicleLabel: 'Возило:',
      submit: 'Монтирај',
      submitting: 'Монтажа...',
      error: 'Грешка приликом монтаже гуме',
      cancel: 'Откажи',
    },
    registerAndMount: {
      title: 'Додај нову гуму на возило',
      vehicleLabel: 'Возило:',
      tireInfoSection: 'Подаци о гуми',
      mountSection: 'Монтажа',
      submit: 'Додај и монтирај',
      submitting: 'Додавање...',
      error: 'Грешка приликом додавања гуме',
      cancel: 'Откажи',
    },
  },
  footer: {
    allRightsReserved: 'Сва права задржана.',
    support: 'Подршка',
    privacyPolicy: 'Политика приватности',
    termsOfUse: 'Услови коришћења',
  },
} as const;
